/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as NoAccessRouteImport } from './routes/no-access'
import { Route as WorkforceRouteRouteImport } from './routes/workforce/route'
import { Route as WorkOrdersRouteRouteImport } from './routes/work-orders/route'
import { Route as Vision_test_plansRouteRouteImport } from './routes/vision_test_plans/route'
import { Route as ShiftPatternsRouteRouteImport } from './routes/shift-patterns/route'
import { Route as QualityPacksRouteRouteImport } from './routes/quality-packs/route'
import { Route as ProjectsRouteRouteImport } from './routes/projects/route'
import { Route as ProductsRouteRouteImport } from './routes/products/route'
import { Route as ProductionPlannerRouteRouteImport } from './routes/production-planner/route'
import { Route as PermissionsRouteRouteImport } from './routes/permissions/route'
import { Route as OperationsStationsGridRouteRouteImport } from './routes/operations-stations-grid/route'
import { Route as OperationsRouteRouteImport } from './routes/operations/route'
import { Route as OperatingCostsRouteRouteImport } from './routes/operating-costs/route'
import { Route as MaterialsRouteRouteImport } from './routes/materials/route'
import { Route as MaterialImportsRouteRouteImport } from './routes/material-imports/route'
import { Route as JobCardsRouteRouteImport } from './routes/job-cards/route'
import { Route as InboxRouteRouteImport } from './routes/inbox/route'
import { Route as ImportsRouteRouteImport } from './routes/imports/route'
import { Route as FactoryRoutesRouteRouteImport } from './routes/factory-routes/route'
import { Route as FactoriesRouteRouteImport } from './routes/factories/route'
import { Route as ColumnsRouteRouteImport } from './routes/columns/route'
import { Route as Cause_categoriesRouteRouteImport } from './routes/cause_categories/route'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkforceIndexRouteImport } from './routes/workforce/index'
import { Route as Vision_test_plansIndexRouteImport } from './routes/vision_test_plans/index'
import { Route as ShiftPatternsIndexRouteImport } from './routes/shift-patterns/index'
import { Route as Run_sheetsIndexRouteImport } from './routes/run_sheets/index'
import { Route as QualityPacksIndexRouteImport } from './routes/quality-packs/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as ProductsIndexRouteImport } from './routes/products/index'
import { Route as ProductionPlannerIndexRouteImport } from './routes/production-planner/index'
import { Route as PermissionsIndexRouteImport } from './routes/permissions/index'
import { Route as OperationsIndexRouteImport } from './routes/operations/index'
import { Route as OperationsStationsGridIndexRouteImport } from './routes/operations-stations-grid/index'
import { Route as OperatingCostsIndexRouteImport } from './routes/operating-costs/index'
import { Route as MaterialsIndexRouteImport } from './routes/materials/index'
import { Route as MaterialImportsIndexRouteImport } from './routes/material-imports/index'
import { Route as JobCardsIndexRouteImport } from './routes/job-cards/index'
import { Route as InboxIndexRouteImport } from './routes/inbox/index'
import { Route as ImportsIndexRouteImport } from './routes/imports/index'
import { Route as FactoryRoutesIndexRouteImport } from './routes/factory-routes/index'
import { Route as FactoriesIndexRouteImport } from './routes/factories/index'
import { Route as DebugIndexRouteImport } from './routes/debug/index'
import { Route as ColumnsIndexRouteImport } from './routes/columns/index'
import { Route as Change_controlIndexRouteImport } from './routes/change_control/index'
import { Route as Cause_categoriesIndexRouteImport } from './routes/cause_categories/index'
import { Route as AuditIndexRouteImport } from './routes/audit/index'
import { Route as WorkforceWorkerIdRouteImport } from './routes/workforce/$workerId'
import { Route as WorkOrdersWorkOrderIdRouteImport } from './routes/work-orders/$workOrderId'
import { Route as Vision_test_plansTest_plan_idRouteImport } from './routes/vision_test_plans/$test_plan_id'
import { Route as ShiftPatternsShift_pattern_idRouteImport } from './routes/shift-patterns/$shift_pattern_id'
import { Route as QualityPacksWorkOrderIdRouteImport } from './routes/quality-packs/$workOrderId'
import { Route as ProjectsTimelineRouteImport } from './routes/projects/timeline'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects/$projectId'
import { Route as ProductsNewRouteImport } from './routes/products/new'
import { Route as ProductsProductIdRouteImport } from './routes/products/$productId'
import { Route as ProductionPlannerTimelineRouteImport } from './routes/production-planner/timeline'
import { Route as OperationsNewRouteImport } from './routes/operations/new'
import { Route as OperationsChecksRouteImport } from './routes/operations/checks'
import { Route as OperationsOperation_idRouteImport } from './routes/operations/$operation_id'
import { Route as OperatingCostsValueAddingRouteImport } from './routes/operating-costs/value-adding'
import { Route as OperatingCostsSupportRouteImport } from './routes/operating-costs/support'
import { Route as OperatingCostsOverheadsRouteImport } from './routes/operating-costs/overheads'
import { Route as OperatingCostsLaborRouteImport } from './routes/operating-costs/labor'
import { Route as MaterialsUsageRouteImport } from './routes/materials/usage'
import { Route as MaterialImportsMaterialImportIdRouteImport } from './routes/material-imports/$materialImportId'
import { Route as JobCardsJobCardIdRouteImport } from './routes/job-cards/$jobCardId'
import { Route as ImportsImportIdRouteImport } from './routes/imports/$importId'
import { Route as Change_controlRun_idRouteImport } from './routes/change_control/$run_id'
import { Route as ProductsContainersRouteRouteImport } from './routes/products/containers/route'
import { Route as OperatingCostsCostToProduceRouteRouteImport } from './routes/operating-costs/cost-to-produce/route'
import { Route as AdminPartnersRouteRouteImport } from './routes/admin/partners/route'
import { Route as AdminFeatureFlagsRouteRouteImport } from './routes/admin/feature-flags/route'
import { Route as AdminDevicesRouteRouteImport } from './routes/admin/devices/route'
import { Route as AdminContainersRouteRouteImport } from './routes/admin/containers/route'
import { Route as Run_sheetsRulesIndexRouteImport } from './routes/run_sheets/rules/index'
import { Route as ProductsContainersIndexRouteImport } from './routes/products/containers/index'
import { Route as OperatingCostsCostToProduceIndexRouteImport } from './routes/operating-costs/cost-to-produce/index'
import { Route as ColumnsStructuredConfigurationIndexRouteImport } from './routes/columns/structured-configuration/index'
import { Route as ColumnsMaterialsIndexRouteImport } from './routes/columns/materials/index'
import { Route as ColumnsCustomConfigurationIndexRouteImport } from './routes/columns/custom-configuration/index'
import { Route as AdminWorkloadCategoriesIndexRouteImport } from './routes/admin/workload-categories/index'
import { Route as AdminPartnersIndexRouteImport } from './routes/admin/partners/index'
import { Route as AdminFeatureFlagsIndexRouteImport } from './routes/admin/feature-flags/index'
import { Route as AdminDevicesIndexRouteImport } from './routes/admin/devices/index'
import { Route as AdminContainersIndexRouteImport } from './routes/admin/containers/index'
import { Route as ProjectsProjectIdTimelineRouteImport } from './routes/projects/$projectId_.timeline'
import { Route as ProjectsProjectIdRun_sheetsRouteImport } from './routes/projects/$projectId_.run_sheets'
import { Route as ProjectsProjectIdReleaseRouteImport } from './routes/projects/$projectId_.release'
import { Route as ProjectsProjectIdRedraftRouteImport } from './routes/projects/$projectId_.redraft'
import { Route as ProjectsProjectIdGanttRouteImport } from './routes/projects/$projectId_.gantt'
import { Route as ProductsContainersContainerIdRouteImport } from './routes/products/containers/$containerId'
import { Route as OperationsOperation_idStationsRouteImport } from './routes/operations/$operation_id_.stations'
import { Route as OperationsOperation_idRun_sheetsRouteImport } from './routes/operations/$operation_id_.run_sheets'
import { Route as OperationsOperation_idChecksRouteImport } from './routes/operations/$operation_id_.checks'
import { Route as OperatingCostsCostToProduceWorkOrderRouteImport } from './routes/operating-costs/cost-to-produce/work-order'
import { Route as OperatingCostsCostToProduceProjectRouteImport } from './routes/operating-costs/cost-to-produce/project'
import { Route as OperatingCostsCostToProduceBudgetsRouteImport } from './routes/operating-costs/cost-to-produce/budgets'
import { Route as DrawingsViewIdRouteImport } from './routes/drawings/view/$id'
import { Route as AdminPartnersPartnerIdRouteImport } from './routes/admin/partners/$partnerId'
import { Route as AdminFeatureFlagsFlagKeyRouteImport } from './routes/admin/feature-flags/$flagKey'
import { Route as AdminDevicesDeviceAuthIdRouteImport } from './routes/admin/devices/$deviceAuthId'
import { Route as AdminContainersContainerIdRouteImport } from './routes/admin/containers/$containerId'
import { Route as Vision_test_plansTest_plan_idRunsRun_idRouteImport } from './routes/vision_test_plans/$test_plan_id_.runs.$run_id'
import { Route as QualityPacksWorkOrderIdJobCardIdOrderNumberRouteImport } from './routes/quality-packs/$workOrderId_.$jobCardId.$orderNumber'

const NoAccessRoute = NoAccessRouteImport.update({
  id: '/no-access',
  path: '/no-access',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkforceRouteRoute = WorkforceRouteRouteImport.update({
  id: '/workforce',
  path: '/workforce',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkOrdersRouteRoute = WorkOrdersRouteRouteImport.update({
  id: '/work-orders',
  path: '/work-orders',
  getParentRoute: () => rootRouteImport,
} as any)
const Vision_test_plansRouteRoute = Vision_test_plansRouteRouteImport.update({
  id: '/vision_test_plans',
  path: '/vision_test_plans',
  getParentRoute: () => rootRouteImport,
} as any)
const ShiftPatternsRouteRoute = ShiftPatternsRouteRouteImport.update({
  id: '/shift-patterns',
  path: '/shift-patterns',
  getParentRoute: () => rootRouteImport,
} as any)
const QualityPacksRouteRoute = QualityPacksRouteRouteImport.update({
  id: '/quality-packs',
  path: '/quality-packs',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsRouteRoute = ProjectsRouteRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRouteRoute = ProductsRouteRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductionPlannerRouteRoute = ProductionPlannerRouteRouteImport.update({
  id: '/production-planner',
  path: '/production-planner',
  getParentRoute: () => rootRouteImport,
} as any)
const PermissionsRouteRoute = PermissionsRouteRouteImport.update({
  id: '/permissions',
  path: '/permissions',
  getParentRoute: () => rootRouteImport,
} as any)
const OperationsStationsGridRouteRoute =
  OperationsStationsGridRouteRouteImport.update({
    id: '/operations-stations-grid',
    path: '/operations-stations-grid',
    getParentRoute: () => rootRouteImport,
  } as any)
const OperationsRouteRoute = OperationsRouteRouteImport.update({
  id: '/operations',
  path: '/operations',
  getParentRoute: () => rootRouteImport,
} as any)
const OperatingCostsRouteRoute = OperatingCostsRouteRouteImport.update({
  id: '/operating-costs',
  path: '/operating-costs',
  getParentRoute: () => rootRouteImport,
} as any)
const MaterialsRouteRoute = MaterialsRouteRouteImport.update({
  id: '/materials',
  path: '/materials',
  getParentRoute: () => rootRouteImport,
} as any)
const MaterialImportsRouteRoute = MaterialImportsRouteRouteImport.update({
  id: '/material-imports',
  path: '/material-imports',
  getParentRoute: () => rootRouteImport,
} as any)
const JobCardsRouteRoute = JobCardsRouteRouteImport.update({
  id: '/job-cards',
  path: '/job-cards',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRouteRoute = InboxRouteRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportsRouteRoute = ImportsRouteRouteImport.update({
  id: '/imports',
  path: '/imports',
  getParentRoute: () => rootRouteImport,
} as any)
const FactoryRoutesRouteRoute = FactoryRoutesRouteRouteImport.update({
  id: '/factory-routes',
  path: '/factory-routes',
  getParentRoute: () => rootRouteImport,
} as any)
const FactoriesRouteRoute = FactoriesRouteRouteImport.update({
  id: '/factories',
  path: '/factories',
  getParentRoute: () => rootRouteImport,
} as any)
const ColumnsRouteRoute = ColumnsRouteRouteImport.update({
  id: '/columns',
  path: '/columns',
  getParentRoute: () => rootRouteImport,
} as any)
const Cause_categoriesRouteRoute = Cause_categoriesRouteRouteImport.update({
  id: '/cause_categories',
  path: '/cause_categories',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkforceIndexRoute = WorkforceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkforceRouteRoute,
} as any)
const Vision_test_plansIndexRoute = Vision_test_plansIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => Vision_test_plansRouteRoute,
} as any)
const ShiftPatternsIndexRoute = ShiftPatternsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShiftPatternsRouteRoute,
} as any)
const Run_sheetsIndexRoute = Run_sheetsIndexRouteImport.update({
  id: '/run_sheets/',
  path: '/run_sheets/',
  getParentRoute: () => rootRouteImport,
} as any)
const QualityPacksIndexRoute = QualityPacksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => QualityPacksRouteRoute,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProjectsRouteRoute,
} as any)
const ProductsIndexRoute = ProductsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProductsRouteRoute,
} as any)
const ProductionPlannerIndexRoute = ProductionPlannerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProductionPlannerRouteRoute,
} as any)
const PermissionsIndexRoute = PermissionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PermissionsRouteRoute,
} as any)
const OperationsIndexRoute = OperationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const OperationsStationsGridIndexRoute =
  OperationsStationsGridIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OperationsStationsGridRouteRoute,
  } as any)
const OperatingCostsIndexRoute = OperatingCostsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OperatingCostsRouteRoute,
} as any)
const MaterialsIndexRoute = MaterialsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MaterialsRouteRoute,
} as any)
const MaterialImportsIndexRoute = MaterialImportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MaterialImportsRouteRoute,
} as any)
const JobCardsIndexRoute = JobCardsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => JobCardsRouteRoute,
} as any)
const InboxIndexRoute = InboxIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InboxRouteRoute,
} as any)
const ImportsIndexRoute = ImportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ImportsRouteRoute,
} as any)
const FactoryRoutesIndexRoute = FactoryRoutesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FactoryRoutesRouteRoute,
} as any)
const FactoriesIndexRoute = FactoriesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FactoriesRouteRoute,
} as any)
const DebugIndexRoute = DebugIndexRouteImport.update({
  id: '/debug/',
  path: '/debug/',
  getParentRoute: () => rootRouteImport,
} as any)
const ColumnsIndexRoute = ColumnsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ColumnsRouteRoute,
} as any)
const Change_controlIndexRoute = Change_controlIndexRouteImport.update({
  id: '/change_control/',
  path: '/change_control/',
  getParentRoute: () => rootRouteImport,
} as any)
const Cause_categoriesIndexRoute = Cause_categoriesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => Cause_categoriesRouteRoute,
} as any)
const AuditIndexRoute = AuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkforceWorkerIdRoute = WorkforceWorkerIdRouteImport.update({
  id: '/$workerId',
  path: '/$workerId',
  getParentRoute: () => WorkforceRouteRoute,
} as any)
const WorkOrdersWorkOrderIdRoute = WorkOrdersWorkOrderIdRouteImport.update({
  id: '/$workOrderId',
  path: '/$workOrderId',
  getParentRoute: () => WorkOrdersRouteRoute,
} as any)
const Vision_test_plansTest_plan_idRoute =
  Vision_test_plansTest_plan_idRouteImport.update({
    id: '/$test_plan_id',
    path: '/$test_plan_id',
    getParentRoute: () => Vision_test_plansRouteRoute,
  } as any)
const ShiftPatternsShift_pattern_idRoute =
  ShiftPatternsShift_pattern_idRouteImport.update({
    id: '/$shift_pattern_id',
    path: '/$shift_pattern_id',
    getParentRoute: () => ShiftPatternsRouteRoute,
  } as any)
const QualityPacksWorkOrderIdRoute = QualityPacksWorkOrderIdRouteImport.update({
  id: '/$workOrderId',
  path: '/$workOrderId',
  getParentRoute: () => QualityPacksRouteRoute,
} as any)
const ProjectsTimelineRoute = ProjectsTimelineRouteImport.update({
  id: '/timeline',
  path: '/timeline',
  getParentRoute: () => ProjectsRouteRoute,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/$projectId',
  path: '/$projectId',
  getParentRoute: () => ProjectsRouteRoute,
} as any)
const ProductsNewRoute = ProductsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => ProductsRouteRoute,
} as any)
const ProductsProductIdRoute = ProductsProductIdRouteImport.update({
  id: '/$productId',
  path: '/$productId',
  getParentRoute: () => ProductsRouteRoute,
} as any)
const ProductionPlannerTimelineRoute =
  ProductionPlannerTimelineRouteImport.update({
    id: '/timeline',
    path: '/timeline',
    getParentRoute: () => ProductionPlannerRouteRoute,
  } as any)
const OperationsNewRoute = OperationsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const OperationsChecksRoute = OperationsChecksRouteImport.update({
  id: '/checks',
  path: '/checks',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const OperationsOperation_idRoute = OperationsOperation_idRouteImport.update({
  id: '/$operation_id',
  path: '/$operation_id',
  getParentRoute: () => OperationsRouteRoute,
} as any)
const OperatingCostsValueAddingRoute =
  OperatingCostsValueAddingRouteImport.update({
    id: '/value-adding',
    path: '/value-adding',
    getParentRoute: () => OperatingCostsRouteRoute,
  } as any)
const OperatingCostsSupportRoute = OperatingCostsSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => OperatingCostsRouteRoute,
} as any)
const OperatingCostsOverheadsRoute = OperatingCostsOverheadsRouteImport.update({
  id: '/overheads',
  path: '/overheads',
  getParentRoute: () => OperatingCostsRouteRoute,
} as any)
const OperatingCostsLaborRoute = OperatingCostsLaborRouteImport.update({
  id: '/labor',
  path: '/labor',
  getParentRoute: () => OperatingCostsRouteRoute,
} as any)
const MaterialsUsageRoute = MaterialsUsageRouteImport.update({
  id: '/usage',
  path: '/usage',
  getParentRoute: () => MaterialsRouteRoute,
} as any)
const MaterialImportsMaterialImportIdRoute =
  MaterialImportsMaterialImportIdRouteImport.update({
    id: '/$materialImportId',
    path: '/$materialImportId',
    getParentRoute: () => MaterialImportsRouteRoute,
  } as any)
const JobCardsJobCardIdRoute = JobCardsJobCardIdRouteImport.update({
  id: '/$jobCardId',
  path: '/$jobCardId',
  getParentRoute: () => JobCardsRouteRoute,
} as any)
const ImportsImportIdRoute = ImportsImportIdRouteImport.update({
  id: '/$importId',
  path: '/$importId',
  getParentRoute: () => ImportsRouteRoute,
} as any)
const Change_controlRun_idRoute = Change_controlRun_idRouteImport.update({
  id: '/change_control/$run_id',
  path: '/change_control/$run_id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsContainersRouteRoute = ProductsContainersRouteRouteImport.update({
  id: '/containers',
  path: '/containers',
  getParentRoute: () => ProductsRouteRoute,
} as any)
const OperatingCostsCostToProduceRouteRoute =
  OperatingCostsCostToProduceRouteRouteImport.update({
    id: '/cost-to-produce',
    path: '/cost-to-produce',
    getParentRoute: () => OperatingCostsRouteRoute,
  } as any)
const AdminPartnersRouteRoute = AdminPartnersRouteRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFeatureFlagsRouteRoute = AdminFeatureFlagsRouteRouteImport.update({
  id: '/feature-flags',
  path: '/feature-flags',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminDevicesRouteRoute = AdminDevicesRouteRouteImport.update({
  id: '/devices',
  path: '/devices',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminContainersRouteRoute = AdminContainersRouteRouteImport.update({
  id: '/containers',
  path: '/containers',
  getParentRoute: () => AdminRouteRoute,
} as any)
const Run_sheetsRulesIndexRoute = Run_sheetsRulesIndexRouteImport.update({
  id: '/run_sheets/rules/',
  path: '/run_sheets/rules/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsContainersIndexRoute = ProductsContainersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProductsContainersRouteRoute,
} as any)
const OperatingCostsCostToProduceIndexRoute =
  OperatingCostsCostToProduceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => OperatingCostsCostToProduceRouteRoute,
  } as any)
const ColumnsStructuredConfigurationIndexRoute =
  ColumnsStructuredConfigurationIndexRouteImport.update({
    id: '/structured-configuration/',
    path: '/structured-configuration/',
    getParentRoute: () => ColumnsRouteRoute,
  } as any)
const ColumnsMaterialsIndexRoute = ColumnsMaterialsIndexRouteImport.update({
  id: '/materials/',
  path: '/materials/',
  getParentRoute: () => ColumnsRouteRoute,
} as any)
const ColumnsCustomConfigurationIndexRoute =
  ColumnsCustomConfigurationIndexRouteImport.update({
    id: '/custom-configuration/',
    path: '/custom-configuration/',
    getParentRoute: () => ColumnsRouteRoute,
  } as any)
const AdminWorkloadCategoriesIndexRoute =
  AdminWorkloadCategoriesIndexRouteImport.update({
    id: '/workload-categories/',
    path: '/workload-categories/',
    getParentRoute: () => AdminRouteRoute,
  } as any)
const AdminPartnersIndexRoute = AdminPartnersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminPartnersRouteRoute,
} as any)
const AdminFeatureFlagsIndexRoute = AdminFeatureFlagsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminFeatureFlagsRouteRoute,
} as any)
const AdminDevicesIndexRoute = AdminDevicesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminDevicesRouteRoute,
} as any)
const AdminContainersIndexRoute = AdminContainersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminContainersRouteRoute,
} as any)
const ProjectsProjectIdTimelineRoute =
  ProjectsProjectIdTimelineRouteImport.update({
    id: '/$projectId_/timeline',
    path: '/$projectId/timeline',
    getParentRoute: () => ProjectsRouteRoute,
  } as any)
const ProjectsProjectIdRun_sheetsRoute =
  ProjectsProjectIdRun_sheetsRouteImport.update({
    id: '/$projectId_/run_sheets',
    path: '/$projectId/run_sheets',
    getParentRoute: () => ProjectsRouteRoute,
  } as any)
const ProjectsProjectIdReleaseRoute =
  ProjectsProjectIdReleaseRouteImport.update({
    id: '/$projectId_/release',
    path: '/$projectId/release',
    getParentRoute: () => ProjectsRouteRoute,
  } as any)
const ProjectsProjectIdRedraftRoute =
  ProjectsProjectIdRedraftRouteImport.update({
    id: '/$projectId_/redraft',
    path: '/$projectId/redraft',
    getParentRoute: () => ProjectsRouteRoute,
  } as any)
const ProjectsProjectIdGanttRoute = ProjectsProjectIdGanttRouteImport.update({
  id: '/$projectId_/gantt',
  path: '/$projectId/gantt',
  getParentRoute: () => ProjectsRouteRoute,
} as any)
const ProductsContainersContainerIdRoute =
  ProductsContainersContainerIdRouteImport.update({
    id: '/$containerId',
    path: '/$containerId',
    getParentRoute: () => ProductsContainersRouteRoute,
  } as any)
const OperationsOperation_idStationsRoute =
  OperationsOperation_idStationsRouteImport.update({
    id: '/$operation_id_/stations',
    path: '/$operation_id/stations',
    getParentRoute: () => OperationsRouteRoute,
  } as any)
const OperationsOperation_idRun_sheetsRoute =
  OperationsOperation_idRun_sheetsRouteImport.update({
    id: '/$operation_id_/run_sheets',
    path: '/$operation_id/run_sheets',
    getParentRoute: () => OperationsRouteRoute,
  } as any)
const OperationsOperation_idChecksRoute =
  OperationsOperation_idChecksRouteImport.update({
    id: '/$operation_id_/checks',
    path: '/$operation_id/checks',
    getParentRoute: () => OperationsRouteRoute,
  } as any)
const OperatingCostsCostToProduceWorkOrderRoute =
  OperatingCostsCostToProduceWorkOrderRouteImport.update({
    id: '/work-order',
    path: '/work-order',
    getParentRoute: () => OperatingCostsCostToProduceRouteRoute,
  } as any)
const OperatingCostsCostToProduceProjectRoute =
  OperatingCostsCostToProduceProjectRouteImport.update({
    id: '/project',
    path: '/project',
    getParentRoute: () => OperatingCostsCostToProduceRouteRoute,
  } as any)
const OperatingCostsCostToProduceBudgetsRoute =
  OperatingCostsCostToProduceBudgetsRouteImport.update({
    id: '/budgets',
    path: '/budgets',
    getParentRoute: () => OperatingCostsCostToProduceRouteRoute,
  } as any)
const DrawingsViewIdRoute = DrawingsViewIdRouteImport.update({
  id: '/drawings/view/$id',
  path: '/drawings/view/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPartnersPartnerIdRoute = AdminPartnersPartnerIdRouteImport.update({
  id: '/$partnerId',
  path: '/$partnerId',
  getParentRoute: () => AdminPartnersRouteRoute,
} as any)
const AdminFeatureFlagsFlagKeyRoute =
  AdminFeatureFlagsFlagKeyRouteImport.update({
    id: '/$flagKey',
    path: '/$flagKey',
    getParentRoute: () => AdminFeatureFlagsRouteRoute,
  } as any)
const AdminDevicesDeviceAuthIdRoute =
  AdminDevicesDeviceAuthIdRouteImport.update({
    id: '/$deviceAuthId',
    path: '/$deviceAuthId',
    getParentRoute: () => AdminDevicesRouteRoute,
  } as any)
const AdminContainersContainerIdRoute =
  AdminContainersContainerIdRouteImport.update({
    id: '/$containerId',
    path: '/$containerId',
    getParentRoute: () => AdminContainersRouteRoute,
  } as any)
const Vision_test_plansTest_plan_idRunsRun_idRoute =
  Vision_test_plansTest_plan_idRunsRun_idRouteImport.update({
    id: '/$test_plan_id_/runs/$run_id',
    path: '/$test_plan_id/runs/$run_id',
    getParentRoute: () => Vision_test_plansRouteRoute,
  } as any)
const QualityPacksWorkOrderIdJobCardIdOrderNumberRoute =
  QualityPacksWorkOrderIdJobCardIdOrderNumberRouteImport.update({
    id: '/$workOrderId_/$jobCardId/$orderNumber',
    path: '/$workOrderId/$jobCardId/$orderNumber',
    getParentRoute: () => QualityPacksRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/cause_categories': typeof Cause_categoriesRouteRouteWithChildren
  '/columns': typeof ColumnsRouteRouteWithChildren
  '/factories': typeof FactoriesRouteRouteWithChildren
  '/factory-routes': typeof FactoryRoutesRouteRouteWithChildren
  '/imports': typeof ImportsRouteRouteWithChildren
  '/inbox': typeof InboxRouteRouteWithChildren
  '/job-cards': typeof JobCardsRouteRouteWithChildren
  '/material-imports': typeof MaterialImportsRouteRouteWithChildren
  '/materials': typeof MaterialsRouteRouteWithChildren
  '/operating-costs': typeof OperatingCostsRouteRouteWithChildren
  '/operations': typeof OperationsRouteRouteWithChildren
  '/operations-stations-grid': typeof OperationsStationsGridRouteRouteWithChildren
  '/permissions': typeof PermissionsRouteRouteWithChildren
  '/production-planner': typeof ProductionPlannerRouteRouteWithChildren
  '/products': typeof ProductsRouteRouteWithChildren
  '/projects': typeof ProjectsRouteRouteWithChildren
  '/quality-packs': typeof QualityPacksRouteRouteWithChildren
  '/shift-patterns': typeof ShiftPatternsRouteRouteWithChildren
  '/vision_test_plans': typeof Vision_test_plansRouteRouteWithChildren
  '/work-orders': typeof WorkOrdersRouteRouteWithChildren
  '/workforce': typeof WorkforceRouteRouteWithChildren
  '/no-access': typeof NoAccessRoute
  '/admin/containers': typeof AdminContainersRouteRouteWithChildren
  '/admin/devices': typeof AdminDevicesRouteRouteWithChildren
  '/admin/feature-flags': typeof AdminFeatureFlagsRouteRouteWithChildren
  '/admin/partners': typeof AdminPartnersRouteRouteWithChildren
  '/operating-costs/cost-to-produce': typeof OperatingCostsCostToProduceRouteRouteWithChildren
  '/products/containers': typeof ProductsContainersRouteRouteWithChildren
  '/change_control/$run_id': typeof Change_controlRun_idRoute
  '/imports/$importId': typeof ImportsImportIdRoute
  '/job-cards/$jobCardId': typeof JobCardsJobCardIdRoute
  '/material-imports/$materialImportId': typeof MaterialImportsMaterialImportIdRoute
  '/materials/usage': typeof MaterialsUsageRoute
  '/operating-costs/labor': typeof OperatingCostsLaborRoute
  '/operating-costs/overheads': typeof OperatingCostsOverheadsRoute
  '/operating-costs/support': typeof OperatingCostsSupportRoute
  '/operating-costs/value-adding': typeof OperatingCostsValueAddingRoute
  '/operations/$operation_id': typeof OperationsOperation_idRoute
  '/operations/checks': typeof OperationsChecksRoute
  '/operations/new': typeof OperationsNewRoute
  '/production-planner/timeline': typeof ProductionPlannerTimelineRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/products/new': typeof ProductsNewRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/timeline': typeof ProjectsTimelineRoute
  '/quality-packs/$workOrderId': typeof QualityPacksWorkOrderIdRoute
  '/shift-patterns/$shift_pattern_id': typeof ShiftPatternsShift_pattern_idRoute
  '/vision_test_plans/$test_plan_id': typeof Vision_test_plansTest_plan_idRoute
  '/work-orders/$workOrderId': typeof WorkOrdersWorkOrderIdRoute
  '/workforce/$workerId': typeof WorkforceWorkerIdRoute
  '/audit/': typeof AuditIndexRoute
  '/cause_categories/': typeof Cause_categoriesIndexRoute
  '/change_control/': typeof Change_controlIndexRoute
  '/columns/': typeof ColumnsIndexRoute
  '/debug/': typeof DebugIndexRoute
  '/factories/': typeof FactoriesIndexRoute
  '/factory-routes/': typeof FactoryRoutesIndexRoute
  '/imports/': typeof ImportsIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/job-cards/': typeof JobCardsIndexRoute
  '/material-imports/': typeof MaterialImportsIndexRoute
  '/materials/': typeof MaterialsIndexRoute
  '/operating-costs/': typeof OperatingCostsIndexRoute
  '/operations-stations-grid/': typeof OperationsStationsGridIndexRoute
  '/operations/': typeof OperationsIndexRoute
  '/permissions/': typeof PermissionsIndexRoute
  '/production-planner/': typeof ProductionPlannerIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/quality-packs/': typeof QualityPacksIndexRoute
  '/run_sheets/': typeof Run_sheetsIndexRoute
  '/shift-patterns/': typeof ShiftPatternsIndexRoute
  '/vision_test_plans/': typeof Vision_test_plansIndexRoute
  '/workforce/': typeof WorkforceIndexRoute
  '/admin/containers/$containerId': typeof AdminContainersContainerIdRoute
  '/admin/devices/$deviceAuthId': typeof AdminDevicesDeviceAuthIdRoute
  '/admin/feature-flags/$flagKey': typeof AdminFeatureFlagsFlagKeyRoute
  '/admin/partners/$partnerId': typeof AdminPartnersPartnerIdRoute
  '/drawings/view/$id': typeof DrawingsViewIdRoute
  '/operating-costs/cost-to-produce/budgets': typeof OperatingCostsCostToProduceBudgetsRoute
  '/operating-costs/cost-to-produce/project': typeof OperatingCostsCostToProduceProjectRoute
  '/operating-costs/cost-to-produce/work-order': typeof OperatingCostsCostToProduceWorkOrderRoute
  '/operations/$operation_id/checks': typeof OperationsOperation_idChecksRoute
  '/operations/$operation_id/run_sheets': typeof OperationsOperation_idRun_sheetsRoute
  '/operations/$operation_id/stations': typeof OperationsOperation_idStationsRoute
  '/products/containers/$containerId': typeof ProductsContainersContainerIdRoute
  '/projects/$projectId/gantt': typeof ProjectsProjectIdGanttRoute
  '/projects/$projectId/redraft': typeof ProjectsProjectIdRedraftRoute
  '/projects/$projectId/release': typeof ProjectsProjectIdReleaseRoute
  '/projects/$projectId/run_sheets': typeof ProjectsProjectIdRun_sheetsRoute
  '/projects/$projectId/timeline': typeof ProjectsProjectIdTimelineRoute
  '/admin/containers/': typeof AdminContainersIndexRoute
  '/admin/devices/': typeof AdminDevicesIndexRoute
  '/admin/feature-flags/': typeof AdminFeatureFlagsIndexRoute
  '/admin/partners/': typeof AdminPartnersIndexRoute
  '/admin/workload-categories/': typeof AdminWorkloadCategoriesIndexRoute
  '/columns/custom-configuration/': typeof ColumnsCustomConfigurationIndexRoute
  '/columns/materials/': typeof ColumnsMaterialsIndexRoute
  '/columns/structured-configuration/': typeof ColumnsStructuredConfigurationIndexRoute
  '/operating-costs/cost-to-produce/': typeof OperatingCostsCostToProduceIndexRoute
  '/products/containers/': typeof ProductsContainersIndexRoute
  '/run_sheets/rules/': typeof Run_sheetsRulesIndexRoute
  '/quality-packs/$workOrderId/$jobCardId/$orderNumber': typeof QualityPacksWorkOrderIdJobCardIdOrderNumberRoute
  '/vision_test_plans/$test_plan_id/runs/$run_id': typeof Vision_test_plansTest_plan_idRunsRun_idRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/work-orders': typeof WorkOrdersRouteRouteWithChildren
  '/no-access': typeof NoAccessRoute
  '/change_control/$run_id': typeof Change_controlRun_idRoute
  '/imports/$importId': typeof ImportsImportIdRoute
  '/job-cards/$jobCardId': typeof JobCardsJobCardIdRoute
  '/material-imports/$materialImportId': typeof MaterialImportsMaterialImportIdRoute
  '/materials/usage': typeof MaterialsUsageRoute
  '/operating-costs/labor': typeof OperatingCostsLaborRoute
  '/operating-costs/overheads': typeof OperatingCostsOverheadsRoute
  '/operating-costs/support': typeof OperatingCostsSupportRoute
  '/operating-costs/value-adding': typeof OperatingCostsValueAddingRoute
  '/operations/$operation_id': typeof OperationsOperation_idRoute
  '/operations/checks': typeof OperationsChecksRoute
  '/operations/new': typeof OperationsNewRoute
  '/production-planner/timeline': typeof ProductionPlannerTimelineRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/products/new': typeof ProductsNewRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/timeline': typeof ProjectsTimelineRoute
  '/quality-packs/$workOrderId': typeof QualityPacksWorkOrderIdRoute
  '/shift-patterns/$shift_pattern_id': typeof ShiftPatternsShift_pattern_idRoute
  '/vision_test_plans/$test_plan_id': typeof Vision_test_plansTest_plan_idRoute
  '/work-orders/$workOrderId': typeof WorkOrdersWorkOrderIdRoute
  '/workforce/$workerId': typeof WorkforceWorkerIdRoute
  '/audit': typeof AuditIndexRoute
  '/cause_categories': typeof Cause_categoriesIndexRoute
  '/change_control': typeof Change_controlIndexRoute
  '/columns': typeof ColumnsIndexRoute
  '/debug': typeof DebugIndexRoute
  '/factories': typeof FactoriesIndexRoute
  '/factory-routes': typeof FactoryRoutesIndexRoute
  '/imports': typeof ImportsIndexRoute
  '/inbox': typeof InboxIndexRoute
  '/job-cards': typeof JobCardsIndexRoute
  '/material-imports': typeof MaterialImportsIndexRoute
  '/materials': typeof MaterialsIndexRoute
  '/operating-costs': typeof OperatingCostsIndexRoute
  '/operations-stations-grid': typeof OperationsStationsGridIndexRoute
  '/operations': typeof OperationsIndexRoute
  '/permissions': typeof PermissionsIndexRoute
  '/production-planner': typeof ProductionPlannerIndexRoute
  '/products': typeof ProductsIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/quality-packs': typeof QualityPacksIndexRoute
  '/run_sheets': typeof Run_sheetsIndexRoute
  '/shift-patterns': typeof ShiftPatternsIndexRoute
  '/vision_test_plans': typeof Vision_test_plansIndexRoute
  '/workforce': typeof WorkforceIndexRoute
  '/admin/containers/$containerId': typeof AdminContainersContainerIdRoute
  '/admin/devices/$deviceAuthId': typeof AdminDevicesDeviceAuthIdRoute
  '/admin/feature-flags/$flagKey': typeof AdminFeatureFlagsFlagKeyRoute
  '/admin/partners/$partnerId': typeof AdminPartnersPartnerIdRoute
  '/drawings/view/$id': typeof DrawingsViewIdRoute
  '/operating-costs/cost-to-produce/budgets': typeof OperatingCostsCostToProduceBudgetsRoute
  '/operating-costs/cost-to-produce/project': typeof OperatingCostsCostToProduceProjectRoute
  '/operating-costs/cost-to-produce/work-order': typeof OperatingCostsCostToProduceWorkOrderRoute
  '/operations/$operation_id/checks': typeof OperationsOperation_idChecksRoute
  '/operations/$operation_id/run_sheets': typeof OperationsOperation_idRun_sheetsRoute
  '/operations/$operation_id/stations': typeof OperationsOperation_idStationsRoute
  '/products/containers/$containerId': typeof ProductsContainersContainerIdRoute
  '/projects/$projectId/gantt': typeof ProjectsProjectIdGanttRoute
  '/projects/$projectId/redraft': typeof ProjectsProjectIdRedraftRoute
  '/projects/$projectId/release': typeof ProjectsProjectIdReleaseRoute
  '/projects/$projectId/run_sheets': typeof ProjectsProjectIdRun_sheetsRoute
  '/projects/$projectId/timeline': typeof ProjectsProjectIdTimelineRoute
  '/admin/containers': typeof AdminContainersIndexRoute
  '/admin/devices': typeof AdminDevicesIndexRoute
  '/admin/feature-flags': typeof AdminFeatureFlagsIndexRoute
  '/admin/partners': typeof AdminPartnersIndexRoute
  '/admin/workload-categories': typeof AdminWorkloadCategoriesIndexRoute
  '/columns/custom-configuration': typeof ColumnsCustomConfigurationIndexRoute
  '/columns/materials': typeof ColumnsMaterialsIndexRoute
  '/columns/structured-configuration': typeof ColumnsStructuredConfigurationIndexRoute
  '/operating-costs/cost-to-produce': typeof OperatingCostsCostToProduceIndexRoute
  '/products/containers': typeof ProductsContainersIndexRoute
  '/run_sheets/rules': typeof Run_sheetsRulesIndexRoute
  '/quality-packs/$workOrderId/$jobCardId/$orderNumber': typeof QualityPacksWorkOrderIdJobCardIdOrderNumberRoute
  '/vision_test_plans/$test_plan_id/runs/$run_id': typeof Vision_test_plansTest_plan_idRunsRun_idRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/cause_categories': typeof Cause_categoriesRouteRouteWithChildren
  '/columns': typeof ColumnsRouteRouteWithChildren
  '/factories': typeof FactoriesRouteRouteWithChildren
  '/factory-routes': typeof FactoryRoutesRouteRouteWithChildren
  '/imports': typeof ImportsRouteRouteWithChildren
  '/inbox': typeof InboxRouteRouteWithChildren
  '/job-cards': typeof JobCardsRouteRouteWithChildren
  '/material-imports': typeof MaterialImportsRouteRouteWithChildren
  '/materials': typeof MaterialsRouteRouteWithChildren
  '/operating-costs': typeof OperatingCostsRouteRouteWithChildren
  '/operations': typeof OperationsRouteRouteWithChildren
  '/operations-stations-grid': typeof OperationsStationsGridRouteRouteWithChildren
  '/permissions': typeof PermissionsRouteRouteWithChildren
  '/production-planner': typeof ProductionPlannerRouteRouteWithChildren
  '/products': typeof ProductsRouteRouteWithChildren
  '/projects': typeof ProjectsRouteRouteWithChildren
  '/quality-packs': typeof QualityPacksRouteRouteWithChildren
  '/shift-patterns': typeof ShiftPatternsRouteRouteWithChildren
  '/vision_test_plans': typeof Vision_test_plansRouteRouteWithChildren
  '/work-orders': typeof WorkOrdersRouteRouteWithChildren
  '/workforce': typeof WorkforceRouteRouteWithChildren
  '/no-access': typeof NoAccessRoute
  '/admin/containers': typeof AdminContainersRouteRouteWithChildren
  '/admin/devices': typeof AdminDevicesRouteRouteWithChildren
  '/admin/feature-flags': typeof AdminFeatureFlagsRouteRouteWithChildren
  '/admin/partners': typeof AdminPartnersRouteRouteWithChildren
  '/operating-costs/cost-to-produce': typeof OperatingCostsCostToProduceRouteRouteWithChildren
  '/products/containers': typeof ProductsContainersRouteRouteWithChildren
  '/change_control/$run_id': typeof Change_controlRun_idRoute
  '/imports/$importId': typeof ImportsImportIdRoute
  '/job-cards/$jobCardId': typeof JobCardsJobCardIdRoute
  '/material-imports/$materialImportId': typeof MaterialImportsMaterialImportIdRoute
  '/materials/usage': typeof MaterialsUsageRoute
  '/operating-costs/labor': typeof OperatingCostsLaborRoute
  '/operating-costs/overheads': typeof OperatingCostsOverheadsRoute
  '/operating-costs/support': typeof OperatingCostsSupportRoute
  '/operating-costs/value-adding': typeof OperatingCostsValueAddingRoute
  '/operations/$operation_id': typeof OperationsOperation_idRoute
  '/operations/checks': typeof OperationsChecksRoute
  '/operations/new': typeof OperationsNewRoute
  '/production-planner/timeline': typeof ProductionPlannerTimelineRoute
  '/products/$productId': typeof ProductsProductIdRoute
  '/products/new': typeof ProductsNewRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/timeline': typeof ProjectsTimelineRoute
  '/quality-packs/$workOrderId': typeof QualityPacksWorkOrderIdRoute
  '/shift-patterns/$shift_pattern_id': typeof ShiftPatternsShift_pattern_idRoute
  '/vision_test_plans/$test_plan_id': typeof Vision_test_plansTest_plan_idRoute
  '/work-orders/$workOrderId': typeof WorkOrdersWorkOrderIdRoute
  '/workforce/$workerId': typeof WorkforceWorkerIdRoute
  '/audit/': typeof AuditIndexRoute
  '/cause_categories/': typeof Cause_categoriesIndexRoute
  '/change_control/': typeof Change_controlIndexRoute
  '/columns/': typeof ColumnsIndexRoute
  '/debug/': typeof DebugIndexRoute
  '/factories/': typeof FactoriesIndexRoute
  '/factory-routes/': typeof FactoryRoutesIndexRoute
  '/imports/': typeof ImportsIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/job-cards/': typeof JobCardsIndexRoute
  '/material-imports/': typeof MaterialImportsIndexRoute
  '/materials/': typeof MaterialsIndexRoute
  '/operating-costs/': typeof OperatingCostsIndexRoute
  '/operations-stations-grid/': typeof OperationsStationsGridIndexRoute
  '/operations/': typeof OperationsIndexRoute
  '/permissions/': typeof PermissionsIndexRoute
  '/production-planner/': typeof ProductionPlannerIndexRoute
  '/products/': typeof ProductsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/quality-packs/': typeof QualityPacksIndexRoute
  '/run_sheets/': typeof Run_sheetsIndexRoute
  '/shift-patterns/': typeof ShiftPatternsIndexRoute
  '/vision_test_plans/': typeof Vision_test_plansIndexRoute
  '/workforce/': typeof WorkforceIndexRoute
  '/admin/containers/$containerId': typeof AdminContainersContainerIdRoute
  '/admin/devices/$deviceAuthId': typeof AdminDevicesDeviceAuthIdRoute
  '/admin/feature-flags/$flagKey': typeof AdminFeatureFlagsFlagKeyRoute
  '/admin/partners/$partnerId': typeof AdminPartnersPartnerIdRoute
  '/drawings/view/$id': typeof DrawingsViewIdRoute
  '/operating-costs/cost-to-produce/budgets': typeof OperatingCostsCostToProduceBudgetsRoute
  '/operating-costs/cost-to-produce/project': typeof OperatingCostsCostToProduceProjectRoute
  '/operating-costs/cost-to-produce/work-order': typeof OperatingCostsCostToProduceWorkOrderRoute
  '/operations/$operation_id_/checks': typeof OperationsOperation_idChecksRoute
  '/operations/$operation_id_/run_sheets': typeof OperationsOperation_idRun_sheetsRoute
  '/operations/$operation_id_/stations': typeof OperationsOperation_idStationsRoute
  '/products/containers/$containerId': typeof ProductsContainersContainerIdRoute
  '/projects/$projectId_/gantt': typeof ProjectsProjectIdGanttRoute
  '/projects/$projectId_/redraft': typeof ProjectsProjectIdRedraftRoute
  '/projects/$projectId_/release': typeof ProjectsProjectIdReleaseRoute
  '/projects/$projectId_/run_sheets': typeof ProjectsProjectIdRun_sheetsRoute
  '/projects/$projectId_/timeline': typeof ProjectsProjectIdTimelineRoute
  '/admin/containers/': typeof AdminContainersIndexRoute
  '/admin/devices/': typeof AdminDevicesIndexRoute
  '/admin/feature-flags/': typeof AdminFeatureFlagsIndexRoute
  '/admin/partners/': typeof AdminPartnersIndexRoute
  '/admin/workload-categories/': typeof AdminWorkloadCategoriesIndexRoute
  '/columns/custom-configuration/': typeof ColumnsCustomConfigurationIndexRoute
  '/columns/materials/': typeof ColumnsMaterialsIndexRoute
  '/columns/structured-configuration/': typeof ColumnsStructuredConfigurationIndexRoute
  '/operating-costs/cost-to-produce/': typeof OperatingCostsCostToProduceIndexRoute
  '/products/containers/': typeof ProductsContainersIndexRoute
  '/run_sheets/rules/': typeof Run_sheetsRulesIndexRoute
  '/quality-packs/$workOrderId_/$jobCardId/$orderNumber': typeof QualityPacksWorkOrderIdJobCardIdOrderNumberRoute
  '/vision_test_plans/$test_plan_id_/runs/$run_id': typeof Vision_test_plansTest_plan_idRunsRun_idRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/cause_categories'
    | '/columns'
    | '/factories'
    | '/factory-routes'
    | '/imports'
    | '/inbox'
    | '/job-cards'
    | '/material-imports'
    | '/materials'
    | '/operating-costs'
    | '/operations'
    | '/operations-stations-grid'
    | '/permissions'
    | '/production-planner'
    | '/products'
    | '/projects'
    | '/quality-packs'
    | '/shift-patterns'
    | '/vision_test_plans'
    | '/work-orders'
    | '/workforce'
    | '/no-access'
    | '/admin/containers'
    | '/admin/devices'
    | '/admin/feature-flags'
    | '/admin/partners'
    | '/operating-costs/cost-to-produce'
    | '/products/containers'
    | '/change_control/$run_id'
    | '/imports/$importId'
    | '/job-cards/$jobCardId'
    | '/material-imports/$materialImportId'
    | '/materials/usage'
    | '/operating-costs/labor'
    | '/operating-costs/overheads'
    | '/operating-costs/support'
    | '/operating-costs/value-adding'
    | '/operations/$operation_id'
    | '/operations/checks'
    | '/operations/new'
    | '/production-planner/timeline'
    | '/products/$productId'
    | '/products/new'
    | '/projects/$projectId'
    | '/projects/timeline'
    | '/quality-packs/$workOrderId'
    | '/shift-patterns/$shift_pattern_id'
    | '/vision_test_plans/$test_plan_id'
    | '/work-orders/$workOrderId'
    | '/workforce/$workerId'
    | '/audit/'
    | '/cause_categories/'
    | '/change_control/'
    | '/columns/'
    | '/debug/'
    | '/factories/'
    | '/factory-routes/'
    | '/imports/'
    | '/inbox/'
    | '/job-cards/'
    | '/material-imports/'
    | '/materials/'
    | '/operating-costs/'
    | '/operations-stations-grid/'
    | '/operations/'
    | '/permissions/'
    | '/production-planner/'
    | '/products/'
    | '/projects/'
    | '/quality-packs/'
    | '/run_sheets/'
    | '/shift-patterns/'
    | '/vision_test_plans/'
    | '/workforce/'
    | '/admin/containers/$containerId'
    | '/admin/devices/$deviceAuthId'
    | '/admin/feature-flags/$flagKey'
    | '/admin/partners/$partnerId'
    | '/drawings/view/$id'
    | '/operating-costs/cost-to-produce/budgets'
    | '/operating-costs/cost-to-produce/project'
    | '/operating-costs/cost-to-produce/work-order'
    | '/operations/$operation_id/checks'
    | '/operations/$operation_id/run_sheets'
    | '/operations/$operation_id/stations'
    | '/products/containers/$containerId'
    | '/projects/$projectId/gantt'
    | '/projects/$projectId/redraft'
    | '/projects/$projectId/release'
    | '/projects/$projectId/run_sheets'
    | '/projects/$projectId/timeline'
    | '/admin/containers/'
    | '/admin/devices/'
    | '/admin/feature-flags/'
    | '/admin/partners/'
    | '/admin/workload-categories/'
    | '/columns/custom-configuration/'
    | '/columns/materials/'
    | '/columns/structured-configuration/'
    | '/operating-costs/cost-to-produce/'
    | '/products/containers/'
    | '/run_sheets/rules/'
    | '/quality-packs/$workOrderId/$jobCardId/$orderNumber'
    | '/vision_test_plans/$test_plan_id/runs/$run_id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/work-orders'
    | '/no-access'
    | '/change_control/$run_id'
    | '/imports/$importId'
    | '/job-cards/$jobCardId'
    | '/material-imports/$materialImportId'
    | '/materials/usage'
    | '/operating-costs/labor'
    | '/operating-costs/overheads'
    | '/operating-costs/support'
    | '/operating-costs/value-adding'
    | '/operations/$operation_id'
    | '/operations/checks'
    | '/operations/new'
    | '/production-planner/timeline'
    | '/products/$productId'
    | '/products/new'
    | '/projects/$projectId'
    | '/projects/timeline'
    | '/quality-packs/$workOrderId'
    | '/shift-patterns/$shift_pattern_id'
    | '/vision_test_plans/$test_plan_id'
    | '/work-orders/$workOrderId'
    | '/workforce/$workerId'
    | '/audit'
    | '/cause_categories'
    | '/change_control'
    | '/columns'
    | '/debug'
    | '/factories'
    | '/factory-routes'
    | '/imports'
    | '/inbox'
    | '/job-cards'
    | '/material-imports'
    | '/materials'
    | '/operating-costs'
    | '/operations-stations-grid'
    | '/operations'
    | '/permissions'
    | '/production-planner'
    | '/products'
    | '/projects'
    | '/quality-packs'
    | '/run_sheets'
    | '/shift-patterns'
    | '/vision_test_plans'
    | '/workforce'
    | '/admin/containers/$containerId'
    | '/admin/devices/$deviceAuthId'
    | '/admin/feature-flags/$flagKey'
    | '/admin/partners/$partnerId'
    | '/drawings/view/$id'
    | '/operating-costs/cost-to-produce/budgets'
    | '/operating-costs/cost-to-produce/project'
    | '/operating-costs/cost-to-produce/work-order'
    | '/operations/$operation_id/checks'
    | '/operations/$operation_id/run_sheets'
    | '/operations/$operation_id/stations'
    | '/products/containers/$containerId'
    | '/projects/$projectId/gantt'
    | '/projects/$projectId/redraft'
    | '/projects/$projectId/release'
    | '/projects/$projectId/run_sheets'
    | '/projects/$projectId/timeline'
    | '/admin/containers'
    | '/admin/devices'
    | '/admin/feature-flags'
    | '/admin/partners'
    | '/admin/workload-categories'
    | '/columns/custom-configuration'
    | '/columns/materials'
    | '/columns/structured-configuration'
    | '/operating-costs/cost-to-produce'
    | '/products/containers'
    | '/run_sheets/rules'
    | '/quality-packs/$workOrderId/$jobCardId/$orderNumber'
    | '/vision_test_plans/$test_plan_id/runs/$run_id'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/cause_categories'
    | '/columns'
    | '/factories'
    | '/factory-routes'
    | '/imports'
    | '/inbox'
    | '/job-cards'
    | '/material-imports'
    | '/materials'
    | '/operating-costs'
    | '/operations'
    | '/operations-stations-grid'
    | '/permissions'
    | '/production-planner'
    | '/products'
    | '/projects'
    | '/quality-packs'
    | '/shift-patterns'
    | '/vision_test_plans'
    | '/work-orders'
    | '/workforce'
    | '/no-access'
    | '/admin/containers'
    | '/admin/devices'
    | '/admin/feature-flags'
    | '/admin/partners'
    | '/operating-costs/cost-to-produce'
    | '/products/containers'
    | '/change_control/$run_id'
    | '/imports/$importId'
    | '/job-cards/$jobCardId'
    | '/material-imports/$materialImportId'
    | '/materials/usage'
    | '/operating-costs/labor'
    | '/operating-costs/overheads'
    | '/operating-costs/support'
    | '/operating-costs/value-adding'
    | '/operations/$operation_id'
    | '/operations/checks'
    | '/operations/new'
    | '/production-planner/timeline'
    | '/products/$productId'
    | '/products/new'
    | '/projects/$projectId'
    | '/projects/timeline'
    | '/quality-packs/$workOrderId'
    | '/shift-patterns/$shift_pattern_id'
    | '/vision_test_plans/$test_plan_id'
    | '/work-orders/$workOrderId'
    | '/workforce/$workerId'
    | '/audit/'
    | '/cause_categories/'
    | '/change_control/'
    | '/columns/'
    | '/debug/'
    | '/factories/'
    | '/factory-routes/'
    | '/imports/'
    | '/inbox/'
    | '/job-cards/'
    | '/material-imports/'
    | '/materials/'
    | '/operating-costs/'
    | '/operations-stations-grid/'
    | '/operations/'
    | '/permissions/'
    | '/production-planner/'
    | '/products/'
    | '/projects/'
    | '/quality-packs/'
    | '/run_sheets/'
    | '/shift-patterns/'
    | '/vision_test_plans/'
    | '/workforce/'
    | '/admin/containers/$containerId'
    | '/admin/devices/$deviceAuthId'
    | '/admin/feature-flags/$flagKey'
    | '/admin/partners/$partnerId'
    | '/drawings/view/$id'
    | '/operating-costs/cost-to-produce/budgets'
    | '/operating-costs/cost-to-produce/project'
    | '/operating-costs/cost-to-produce/work-order'
    | '/operations/$operation_id_/checks'
    | '/operations/$operation_id_/run_sheets'
    | '/operations/$operation_id_/stations'
    | '/products/containers/$containerId'
    | '/projects/$projectId_/gantt'
    | '/projects/$projectId_/redraft'
    | '/projects/$projectId_/release'
    | '/projects/$projectId_/run_sheets'
    | '/projects/$projectId_/timeline'
    | '/admin/containers/'
    | '/admin/devices/'
    | '/admin/feature-flags/'
    | '/admin/partners/'
    | '/admin/workload-categories/'
    | '/columns/custom-configuration/'
    | '/columns/materials/'
    | '/columns/structured-configuration/'
    | '/operating-costs/cost-to-produce/'
    | '/products/containers/'
    | '/run_sheets/rules/'
    | '/quality-packs/$workOrderId_/$jobCardId/$orderNumber'
    | '/vision_test_plans/$test_plan_id_/runs/$run_id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  Cause_categoriesRouteRoute: typeof Cause_categoriesRouteRouteWithChildren
  ColumnsRouteRoute: typeof ColumnsRouteRouteWithChildren
  FactoriesRouteRoute: typeof FactoriesRouteRouteWithChildren
  FactoryRoutesRouteRoute: typeof FactoryRoutesRouteRouteWithChildren
  ImportsRouteRoute: typeof ImportsRouteRouteWithChildren
  InboxRouteRoute: typeof InboxRouteRouteWithChildren
  JobCardsRouteRoute: typeof JobCardsRouteRouteWithChildren
  MaterialImportsRouteRoute: typeof MaterialImportsRouteRouteWithChildren
  MaterialsRouteRoute: typeof MaterialsRouteRouteWithChildren
  OperatingCostsRouteRoute: typeof OperatingCostsRouteRouteWithChildren
  OperationsRouteRoute: typeof OperationsRouteRouteWithChildren
  OperationsStationsGridRouteRoute: typeof OperationsStationsGridRouteRouteWithChildren
  PermissionsRouteRoute: typeof PermissionsRouteRouteWithChildren
  ProductionPlannerRouteRoute: typeof ProductionPlannerRouteRouteWithChildren
  ProductsRouteRoute: typeof ProductsRouteRouteWithChildren
  ProjectsRouteRoute: typeof ProjectsRouteRouteWithChildren
  QualityPacksRouteRoute: typeof QualityPacksRouteRouteWithChildren
  ShiftPatternsRouteRoute: typeof ShiftPatternsRouteRouteWithChildren
  Vision_test_plansRouteRoute: typeof Vision_test_plansRouteRouteWithChildren
  WorkOrdersRouteRoute: typeof WorkOrdersRouteRouteWithChildren
  WorkforceRouteRoute: typeof WorkforceRouteRouteWithChildren
  NoAccessRoute: typeof NoAccessRoute
  Change_controlRun_idRoute: typeof Change_controlRun_idRoute
  AuditIndexRoute: typeof AuditIndexRoute
  Change_controlIndexRoute: typeof Change_controlIndexRoute
  DebugIndexRoute: typeof DebugIndexRoute
  Run_sheetsIndexRoute: typeof Run_sheetsIndexRoute
  DrawingsViewIdRoute: typeof DrawingsViewIdRoute
  Run_sheetsRulesIndexRoute: typeof Run_sheetsRulesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/no-access': {
      id: '/no-access'
      path: '/no-access'
      fullPath: '/no-access'
      preLoaderRoute: typeof NoAccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workforce': {
      id: '/workforce'
      path: '/workforce'
      fullPath: '/workforce'
      preLoaderRoute: typeof WorkforceRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-orders': {
      id: '/work-orders'
      path: '/work-orders'
      fullPath: '/work-orders'
      preLoaderRoute: typeof WorkOrdersRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vision_test_plans': {
      id: '/vision_test_plans'
      path: '/vision_test_plans'
      fullPath: '/vision_test_plans'
      preLoaderRoute: typeof Vision_test_plansRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shift-patterns': {
      id: '/shift-patterns'
      path: '/shift-patterns'
      fullPath: '/shift-patterns'
      preLoaderRoute: typeof ShiftPatternsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quality-packs': {
      id: '/quality-packs'
      path: '/quality-packs'
      fullPath: '/quality-packs'
      preLoaderRoute: typeof QualityPacksRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/production-planner': {
      id: '/production-planner'
      path: '/production-planner'
      fullPath: '/production-planner'
      preLoaderRoute: typeof ProductionPlannerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/permissions': {
      id: '/permissions'
      path: '/permissions'
      fullPath: '/permissions'
      preLoaderRoute: typeof PermissionsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operations-stations-grid': {
      id: '/operations-stations-grid'
      path: '/operations-stations-grid'
      fullPath: '/operations-stations-grid'
      preLoaderRoute: typeof OperationsStationsGridRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operations': {
      id: '/operations'
      path: '/operations'
      fullPath: '/operations'
      preLoaderRoute: typeof OperationsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operating-costs': {
      id: '/operating-costs'
      path: '/operating-costs'
      fullPath: '/operating-costs'
      preLoaderRoute: typeof OperatingCostsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/materials': {
      id: '/materials'
      path: '/materials'
      fullPath: '/materials'
      preLoaderRoute: typeof MaterialsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/material-imports': {
      id: '/material-imports'
      path: '/material-imports'
      fullPath: '/material-imports'
      preLoaderRoute: typeof MaterialImportsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/job-cards': {
      id: '/job-cards'
      path: '/job-cards'
      fullPath: '/job-cards'
      preLoaderRoute: typeof JobCardsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/imports': {
      id: '/imports'
      path: '/imports'
      fullPath: '/imports'
      preLoaderRoute: typeof ImportsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/factory-routes': {
      id: '/factory-routes'
      path: '/factory-routes'
      fullPath: '/factory-routes'
      preLoaderRoute: typeof FactoryRoutesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/factories': {
      id: '/factories'
      path: '/factories'
      fullPath: '/factories'
      preLoaderRoute: typeof FactoriesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/columns': {
      id: '/columns'
      path: '/columns'
      fullPath: '/columns'
      preLoaderRoute: typeof ColumnsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cause_categories': {
      id: '/cause_categories'
      path: '/cause_categories'
      fullPath: '/cause_categories'
      preLoaderRoute: typeof Cause_categoriesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workforce/': {
      id: '/workforce/'
      path: '/'
      fullPath: '/workforce/'
      preLoaderRoute: typeof WorkforceIndexRouteImport
      parentRoute: typeof WorkforceRouteRoute
    }
    '/vision_test_plans/': {
      id: '/vision_test_plans/'
      path: '/'
      fullPath: '/vision_test_plans/'
      preLoaderRoute: typeof Vision_test_plansIndexRouteImport
      parentRoute: typeof Vision_test_plansRouteRoute
    }
    '/shift-patterns/': {
      id: '/shift-patterns/'
      path: '/'
      fullPath: '/shift-patterns/'
      preLoaderRoute: typeof ShiftPatternsIndexRouteImport
      parentRoute: typeof ShiftPatternsRouteRoute
    }
    '/run_sheets/': {
      id: '/run_sheets/'
      path: '/run_sheets'
      fullPath: '/run_sheets/'
      preLoaderRoute: typeof Run_sheetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quality-packs/': {
      id: '/quality-packs/'
      path: '/'
      fullPath: '/quality-packs/'
      preLoaderRoute: typeof QualityPacksIndexRouteImport
      parentRoute: typeof QualityPacksRouteRoute
    }
    '/projects/': {
      id: '/projects/'
      path: '/'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof ProjectsRouteRoute
    }
    '/products/': {
      id: '/products/'
      path: '/'
      fullPath: '/products/'
      preLoaderRoute: typeof ProductsIndexRouteImport
      parentRoute: typeof ProductsRouteRoute
    }
    '/production-planner/': {
      id: '/production-planner/'
      path: '/'
      fullPath: '/production-planner/'
      preLoaderRoute: typeof ProductionPlannerIndexRouteImport
      parentRoute: typeof ProductionPlannerRouteRoute
    }
    '/permissions/': {
      id: '/permissions/'
      path: '/'
      fullPath: '/permissions/'
      preLoaderRoute: typeof PermissionsIndexRouteImport
      parentRoute: typeof PermissionsRouteRoute
    }
    '/operations/': {
      id: '/operations/'
      path: '/'
      fullPath: '/operations/'
      preLoaderRoute: typeof OperationsIndexRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations-stations-grid/': {
      id: '/operations-stations-grid/'
      path: '/'
      fullPath: '/operations-stations-grid/'
      preLoaderRoute: typeof OperationsStationsGridIndexRouteImport
      parentRoute: typeof OperationsStationsGridRouteRoute
    }
    '/operating-costs/': {
      id: '/operating-costs/'
      path: '/'
      fullPath: '/operating-costs/'
      preLoaderRoute: typeof OperatingCostsIndexRouteImport
      parentRoute: typeof OperatingCostsRouteRoute
    }
    '/materials/': {
      id: '/materials/'
      path: '/'
      fullPath: '/materials/'
      preLoaderRoute: typeof MaterialsIndexRouteImport
      parentRoute: typeof MaterialsRouteRoute
    }
    '/material-imports/': {
      id: '/material-imports/'
      path: '/'
      fullPath: '/material-imports/'
      preLoaderRoute: typeof MaterialImportsIndexRouteImport
      parentRoute: typeof MaterialImportsRouteRoute
    }
    '/job-cards/': {
      id: '/job-cards/'
      path: '/'
      fullPath: '/job-cards/'
      preLoaderRoute: typeof JobCardsIndexRouteImport
      parentRoute: typeof JobCardsRouteRoute
    }
    '/inbox/': {
      id: '/inbox/'
      path: '/'
      fullPath: '/inbox/'
      preLoaderRoute: typeof InboxIndexRouteImport
      parentRoute: typeof InboxRouteRoute
    }
    '/imports/': {
      id: '/imports/'
      path: '/'
      fullPath: '/imports/'
      preLoaderRoute: typeof ImportsIndexRouteImport
      parentRoute: typeof ImportsRouteRoute
    }
    '/factory-routes/': {
      id: '/factory-routes/'
      path: '/'
      fullPath: '/factory-routes/'
      preLoaderRoute: typeof FactoryRoutesIndexRouteImport
      parentRoute: typeof FactoryRoutesRouteRoute
    }
    '/factories/': {
      id: '/factories/'
      path: '/'
      fullPath: '/factories/'
      preLoaderRoute: typeof FactoriesIndexRouteImport
      parentRoute: typeof FactoriesRouteRoute
    }
    '/debug/': {
      id: '/debug/'
      path: '/debug'
      fullPath: '/debug/'
      preLoaderRoute: typeof DebugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/columns/': {
      id: '/columns/'
      path: '/'
      fullPath: '/columns/'
      preLoaderRoute: typeof ColumnsIndexRouteImport
      parentRoute: typeof ColumnsRouteRoute
    }
    '/change_control/': {
      id: '/change_control/'
      path: '/change_control'
      fullPath: '/change_control/'
      preLoaderRoute: typeof Change_controlIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cause_categories/': {
      id: '/cause_categories/'
      path: '/'
      fullPath: '/cause_categories/'
      preLoaderRoute: typeof Cause_categoriesIndexRouteImport
      parentRoute: typeof Cause_categoriesRouteRoute
    }
    '/audit/': {
      id: '/audit/'
      path: '/audit'
      fullPath: '/audit/'
      preLoaderRoute: typeof AuditIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workforce/$workerId': {
      id: '/workforce/$workerId'
      path: '/$workerId'
      fullPath: '/workforce/$workerId'
      preLoaderRoute: typeof WorkforceWorkerIdRouteImport
      parentRoute: typeof WorkforceRouteRoute
    }
    '/work-orders/$workOrderId': {
      id: '/work-orders/$workOrderId'
      path: '/$workOrderId'
      fullPath: '/work-orders/$workOrderId'
      preLoaderRoute: typeof WorkOrdersWorkOrderIdRouteImport
      parentRoute: typeof WorkOrdersRouteRoute
    }
    '/vision_test_plans/$test_plan_id': {
      id: '/vision_test_plans/$test_plan_id'
      path: '/$test_plan_id'
      fullPath: '/vision_test_plans/$test_plan_id'
      preLoaderRoute: typeof Vision_test_plansTest_plan_idRouteImport
      parentRoute: typeof Vision_test_plansRouteRoute
    }
    '/shift-patterns/$shift_pattern_id': {
      id: '/shift-patterns/$shift_pattern_id'
      path: '/$shift_pattern_id'
      fullPath: '/shift-patterns/$shift_pattern_id'
      preLoaderRoute: typeof ShiftPatternsShift_pattern_idRouteImport
      parentRoute: typeof ShiftPatternsRouteRoute
    }
    '/quality-packs/$workOrderId': {
      id: '/quality-packs/$workOrderId'
      path: '/$workOrderId'
      fullPath: '/quality-packs/$workOrderId'
      preLoaderRoute: typeof QualityPacksWorkOrderIdRouteImport
      parentRoute: typeof QualityPacksRouteRoute
    }
    '/projects/timeline': {
      id: '/projects/timeline'
      path: '/timeline'
      fullPath: '/projects/timeline'
      preLoaderRoute: typeof ProjectsTimelineRouteImport
      parentRoute: typeof ProjectsRouteRoute
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof ProjectsRouteRoute
    }
    '/products/new': {
      id: '/products/new'
      path: '/new'
      fullPath: '/products/new'
      preLoaderRoute: typeof ProductsNewRouteImport
      parentRoute: typeof ProductsRouteRoute
    }
    '/products/$productId': {
      id: '/products/$productId'
      path: '/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof ProductsProductIdRouteImport
      parentRoute: typeof ProductsRouteRoute
    }
    '/production-planner/timeline': {
      id: '/production-planner/timeline'
      path: '/timeline'
      fullPath: '/production-planner/timeline'
      preLoaderRoute: typeof ProductionPlannerTimelineRouteImport
      parentRoute: typeof ProductionPlannerRouteRoute
    }
    '/operations/new': {
      id: '/operations/new'
      path: '/new'
      fullPath: '/operations/new'
      preLoaderRoute: typeof OperationsNewRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/checks': {
      id: '/operations/checks'
      path: '/checks'
      fullPath: '/operations/checks'
      preLoaderRoute: typeof OperationsChecksRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/$operation_id': {
      id: '/operations/$operation_id'
      path: '/$operation_id'
      fullPath: '/operations/$operation_id'
      preLoaderRoute: typeof OperationsOperation_idRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operating-costs/value-adding': {
      id: '/operating-costs/value-adding'
      path: '/value-adding'
      fullPath: '/operating-costs/value-adding'
      preLoaderRoute: typeof OperatingCostsValueAddingRouteImport
      parentRoute: typeof OperatingCostsRouteRoute
    }
    '/operating-costs/support': {
      id: '/operating-costs/support'
      path: '/support'
      fullPath: '/operating-costs/support'
      preLoaderRoute: typeof OperatingCostsSupportRouteImport
      parentRoute: typeof OperatingCostsRouteRoute
    }
    '/operating-costs/overheads': {
      id: '/operating-costs/overheads'
      path: '/overheads'
      fullPath: '/operating-costs/overheads'
      preLoaderRoute: typeof OperatingCostsOverheadsRouteImport
      parentRoute: typeof OperatingCostsRouteRoute
    }
    '/operating-costs/labor': {
      id: '/operating-costs/labor'
      path: '/labor'
      fullPath: '/operating-costs/labor'
      preLoaderRoute: typeof OperatingCostsLaborRouteImport
      parentRoute: typeof OperatingCostsRouteRoute
    }
    '/materials/usage': {
      id: '/materials/usage'
      path: '/usage'
      fullPath: '/materials/usage'
      preLoaderRoute: typeof MaterialsUsageRouteImport
      parentRoute: typeof MaterialsRouteRoute
    }
    '/material-imports/$materialImportId': {
      id: '/material-imports/$materialImportId'
      path: '/$materialImportId'
      fullPath: '/material-imports/$materialImportId'
      preLoaderRoute: typeof MaterialImportsMaterialImportIdRouteImport
      parentRoute: typeof MaterialImportsRouteRoute
    }
    '/job-cards/$jobCardId': {
      id: '/job-cards/$jobCardId'
      path: '/$jobCardId'
      fullPath: '/job-cards/$jobCardId'
      preLoaderRoute: typeof JobCardsJobCardIdRouteImport
      parentRoute: typeof JobCardsRouteRoute
    }
    '/imports/$importId': {
      id: '/imports/$importId'
      path: '/$importId'
      fullPath: '/imports/$importId'
      preLoaderRoute: typeof ImportsImportIdRouteImport
      parentRoute: typeof ImportsRouteRoute
    }
    '/change_control/$run_id': {
      id: '/change_control/$run_id'
      path: '/change_control/$run_id'
      fullPath: '/change_control/$run_id'
      preLoaderRoute: typeof Change_controlRun_idRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/containers': {
      id: '/products/containers'
      path: '/containers'
      fullPath: '/products/containers'
      preLoaderRoute: typeof ProductsContainersRouteRouteImport
      parentRoute: typeof ProductsRouteRoute
    }
    '/operating-costs/cost-to-produce': {
      id: '/operating-costs/cost-to-produce'
      path: '/cost-to-produce'
      fullPath: '/operating-costs/cost-to-produce'
      preLoaderRoute: typeof OperatingCostsCostToProduceRouteRouteImport
      parentRoute: typeof OperatingCostsRouteRoute
    }
    '/admin/partners': {
      id: '/admin/partners'
      path: '/partners'
      fullPath: '/admin/partners'
      preLoaderRoute: typeof AdminPartnersRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/feature-flags': {
      id: '/admin/feature-flags'
      path: '/feature-flags'
      fullPath: '/admin/feature-flags'
      preLoaderRoute: typeof AdminFeatureFlagsRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/devices': {
      id: '/admin/devices'
      path: '/devices'
      fullPath: '/admin/devices'
      preLoaderRoute: typeof AdminDevicesRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/containers': {
      id: '/admin/containers'
      path: '/containers'
      fullPath: '/admin/containers'
      preLoaderRoute: typeof AdminContainersRouteRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/run_sheets/rules/': {
      id: '/run_sheets/rules/'
      path: '/run_sheets/rules'
      fullPath: '/run_sheets/rules/'
      preLoaderRoute: typeof Run_sheetsRulesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/containers/': {
      id: '/products/containers/'
      path: '/'
      fullPath: '/products/containers/'
      preLoaderRoute: typeof ProductsContainersIndexRouteImport
      parentRoute: typeof ProductsContainersRouteRoute
    }
    '/operating-costs/cost-to-produce/': {
      id: '/operating-costs/cost-to-produce/'
      path: '/'
      fullPath: '/operating-costs/cost-to-produce/'
      preLoaderRoute: typeof OperatingCostsCostToProduceIndexRouteImport
      parentRoute: typeof OperatingCostsCostToProduceRouteRoute
    }
    '/columns/structured-configuration/': {
      id: '/columns/structured-configuration/'
      path: '/structured-configuration'
      fullPath: '/columns/structured-configuration/'
      preLoaderRoute: typeof ColumnsStructuredConfigurationIndexRouteImport
      parentRoute: typeof ColumnsRouteRoute
    }
    '/columns/materials/': {
      id: '/columns/materials/'
      path: '/materials'
      fullPath: '/columns/materials/'
      preLoaderRoute: typeof ColumnsMaterialsIndexRouteImport
      parentRoute: typeof ColumnsRouteRoute
    }
    '/columns/custom-configuration/': {
      id: '/columns/custom-configuration/'
      path: '/custom-configuration'
      fullPath: '/columns/custom-configuration/'
      preLoaderRoute: typeof ColumnsCustomConfigurationIndexRouteImport
      parentRoute: typeof ColumnsRouteRoute
    }
    '/admin/workload-categories/': {
      id: '/admin/workload-categories/'
      path: '/workload-categories'
      fullPath: '/admin/workload-categories/'
      preLoaderRoute: typeof AdminWorkloadCategoriesIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/partners/': {
      id: '/admin/partners/'
      path: '/'
      fullPath: '/admin/partners/'
      preLoaderRoute: typeof AdminPartnersIndexRouteImport
      parentRoute: typeof AdminPartnersRouteRoute
    }
    '/admin/feature-flags/': {
      id: '/admin/feature-flags/'
      path: '/'
      fullPath: '/admin/feature-flags/'
      preLoaderRoute: typeof AdminFeatureFlagsIndexRouteImport
      parentRoute: typeof AdminFeatureFlagsRouteRoute
    }
    '/admin/devices/': {
      id: '/admin/devices/'
      path: '/'
      fullPath: '/admin/devices/'
      preLoaderRoute: typeof AdminDevicesIndexRouteImport
      parentRoute: typeof AdminDevicesRouteRoute
    }
    '/admin/containers/': {
      id: '/admin/containers/'
      path: '/'
      fullPath: '/admin/containers/'
      preLoaderRoute: typeof AdminContainersIndexRouteImport
      parentRoute: typeof AdminContainersRouteRoute
    }
    '/projects/$projectId_/timeline': {
      id: '/projects/$projectId_/timeline'
      path: '/$projectId/timeline'
      fullPath: '/projects/$projectId/timeline'
      preLoaderRoute: typeof ProjectsProjectIdTimelineRouteImport
      parentRoute: typeof ProjectsRouteRoute
    }
    '/projects/$projectId_/run_sheets': {
      id: '/projects/$projectId_/run_sheets'
      path: '/$projectId/run_sheets'
      fullPath: '/projects/$projectId/run_sheets'
      preLoaderRoute: typeof ProjectsProjectIdRun_sheetsRouteImport
      parentRoute: typeof ProjectsRouteRoute
    }
    '/projects/$projectId_/release': {
      id: '/projects/$projectId_/release'
      path: '/$projectId/release'
      fullPath: '/projects/$projectId/release'
      preLoaderRoute: typeof ProjectsProjectIdReleaseRouteImport
      parentRoute: typeof ProjectsRouteRoute
    }
    '/projects/$projectId_/redraft': {
      id: '/projects/$projectId_/redraft'
      path: '/$projectId/redraft'
      fullPath: '/projects/$projectId/redraft'
      preLoaderRoute: typeof ProjectsProjectIdRedraftRouteImport
      parentRoute: typeof ProjectsRouteRoute
    }
    '/projects/$projectId_/gantt': {
      id: '/projects/$projectId_/gantt'
      path: '/$projectId/gantt'
      fullPath: '/projects/$projectId/gantt'
      preLoaderRoute: typeof ProjectsProjectIdGanttRouteImport
      parentRoute: typeof ProjectsRouteRoute
    }
    '/products/containers/$containerId': {
      id: '/products/containers/$containerId'
      path: '/$containerId'
      fullPath: '/products/containers/$containerId'
      preLoaderRoute: typeof ProductsContainersContainerIdRouteImport
      parentRoute: typeof ProductsContainersRouteRoute
    }
    '/operations/$operation_id_/stations': {
      id: '/operations/$operation_id_/stations'
      path: '/$operation_id/stations'
      fullPath: '/operations/$operation_id/stations'
      preLoaderRoute: typeof OperationsOperation_idStationsRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/$operation_id_/run_sheets': {
      id: '/operations/$operation_id_/run_sheets'
      path: '/$operation_id/run_sheets'
      fullPath: '/operations/$operation_id/run_sheets'
      preLoaderRoute: typeof OperationsOperation_idRun_sheetsRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operations/$operation_id_/checks': {
      id: '/operations/$operation_id_/checks'
      path: '/$operation_id/checks'
      fullPath: '/operations/$operation_id/checks'
      preLoaderRoute: typeof OperationsOperation_idChecksRouteImport
      parentRoute: typeof OperationsRouteRoute
    }
    '/operating-costs/cost-to-produce/work-order': {
      id: '/operating-costs/cost-to-produce/work-order'
      path: '/work-order'
      fullPath: '/operating-costs/cost-to-produce/work-order'
      preLoaderRoute: typeof OperatingCostsCostToProduceWorkOrderRouteImport
      parentRoute: typeof OperatingCostsCostToProduceRouteRoute
    }
    '/operating-costs/cost-to-produce/project': {
      id: '/operating-costs/cost-to-produce/project'
      path: '/project'
      fullPath: '/operating-costs/cost-to-produce/project'
      preLoaderRoute: typeof OperatingCostsCostToProduceProjectRouteImport
      parentRoute: typeof OperatingCostsCostToProduceRouteRoute
    }
    '/operating-costs/cost-to-produce/budgets': {
      id: '/operating-costs/cost-to-produce/budgets'
      path: '/budgets'
      fullPath: '/operating-costs/cost-to-produce/budgets'
      preLoaderRoute: typeof OperatingCostsCostToProduceBudgetsRouteImport
      parentRoute: typeof OperatingCostsCostToProduceRouteRoute
    }
    '/drawings/view/$id': {
      id: '/drawings/view/$id'
      path: '/drawings/view/$id'
      fullPath: '/drawings/view/$id'
      preLoaderRoute: typeof DrawingsViewIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/partners/$partnerId': {
      id: '/admin/partners/$partnerId'
      path: '/$partnerId'
      fullPath: '/admin/partners/$partnerId'
      preLoaderRoute: typeof AdminPartnersPartnerIdRouteImport
      parentRoute: typeof AdminPartnersRouteRoute
    }
    '/admin/feature-flags/$flagKey': {
      id: '/admin/feature-flags/$flagKey'
      path: '/$flagKey'
      fullPath: '/admin/feature-flags/$flagKey'
      preLoaderRoute: typeof AdminFeatureFlagsFlagKeyRouteImport
      parentRoute: typeof AdminFeatureFlagsRouteRoute
    }
    '/admin/devices/$deviceAuthId': {
      id: '/admin/devices/$deviceAuthId'
      path: '/$deviceAuthId'
      fullPath: '/admin/devices/$deviceAuthId'
      preLoaderRoute: typeof AdminDevicesDeviceAuthIdRouteImport
      parentRoute: typeof AdminDevicesRouteRoute
    }
    '/admin/containers/$containerId': {
      id: '/admin/containers/$containerId'
      path: '/$containerId'
      fullPath: '/admin/containers/$containerId'
      preLoaderRoute: typeof AdminContainersContainerIdRouteImport
      parentRoute: typeof AdminContainersRouteRoute
    }
    '/vision_test_plans/$test_plan_id_/runs/$run_id': {
      id: '/vision_test_plans/$test_plan_id_/runs/$run_id'
      path: '/$test_plan_id/runs/$run_id'
      fullPath: '/vision_test_plans/$test_plan_id/runs/$run_id'
      preLoaderRoute: typeof Vision_test_plansTest_plan_idRunsRun_idRouteImport
      parentRoute: typeof Vision_test_plansRouteRoute
    }
    '/quality-packs/$workOrderId_/$jobCardId/$orderNumber': {
      id: '/quality-packs/$workOrderId_/$jobCardId/$orderNumber'
      path: '/$workOrderId/$jobCardId/$orderNumber'
      fullPath: '/quality-packs/$workOrderId/$jobCardId/$orderNumber'
      preLoaderRoute: typeof QualityPacksWorkOrderIdJobCardIdOrderNumberRouteImport
      parentRoute: typeof QualityPacksRouteRoute
    }
  }
}

interface AdminContainersRouteRouteChildren {
  AdminContainersContainerIdRoute: typeof AdminContainersContainerIdRoute
  AdminContainersIndexRoute: typeof AdminContainersIndexRoute
}

const AdminContainersRouteRouteChildren: AdminContainersRouteRouteChildren = {
  AdminContainersContainerIdRoute: AdminContainersContainerIdRoute,
  AdminContainersIndexRoute: AdminContainersIndexRoute,
}

const AdminContainersRouteRouteWithChildren =
  AdminContainersRouteRoute._addFileChildren(AdminContainersRouteRouteChildren)

interface AdminDevicesRouteRouteChildren {
  AdminDevicesDeviceAuthIdRoute: typeof AdminDevicesDeviceAuthIdRoute
  AdminDevicesIndexRoute: typeof AdminDevicesIndexRoute
}

const AdminDevicesRouteRouteChildren: AdminDevicesRouteRouteChildren = {
  AdminDevicesDeviceAuthIdRoute: AdminDevicesDeviceAuthIdRoute,
  AdminDevicesIndexRoute: AdminDevicesIndexRoute,
}

const AdminDevicesRouteRouteWithChildren =
  AdminDevicesRouteRoute._addFileChildren(AdminDevicesRouteRouteChildren)

interface AdminFeatureFlagsRouteRouteChildren {
  AdminFeatureFlagsFlagKeyRoute: typeof AdminFeatureFlagsFlagKeyRoute
  AdminFeatureFlagsIndexRoute: typeof AdminFeatureFlagsIndexRoute
}

const AdminFeatureFlagsRouteRouteChildren: AdminFeatureFlagsRouteRouteChildren =
  {
    AdminFeatureFlagsFlagKeyRoute: AdminFeatureFlagsFlagKeyRoute,
    AdminFeatureFlagsIndexRoute: AdminFeatureFlagsIndexRoute,
  }

const AdminFeatureFlagsRouteRouteWithChildren =
  AdminFeatureFlagsRouteRoute._addFileChildren(
    AdminFeatureFlagsRouteRouteChildren,
  )

interface AdminPartnersRouteRouteChildren {
  AdminPartnersPartnerIdRoute: typeof AdminPartnersPartnerIdRoute
  AdminPartnersIndexRoute: typeof AdminPartnersIndexRoute
}

const AdminPartnersRouteRouteChildren: AdminPartnersRouteRouteChildren = {
  AdminPartnersPartnerIdRoute: AdminPartnersPartnerIdRoute,
  AdminPartnersIndexRoute: AdminPartnersIndexRoute,
}

const AdminPartnersRouteRouteWithChildren =
  AdminPartnersRouteRoute._addFileChildren(AdminPartnersRouteRouteChildren)

interface AdminRouteRouteChildren {
  AdminContainersRouteRoute: typeof AdminContainersRouteRouteWithChildren
  AdminDevicesRouteRoute: typeof AdminDevicesRouteRouteWithChildren
  AdminFeatureFlagsRouteRoute: typeof AdminFeatureFlagsRouteRouteWithChildren
  AdminPartnersRouteRoute: typeof AdminPartnersRouteRouteWithChildren
  AdminWorkloadCategoriesIndexRoute: typeof AdminWorkloadCategoriesIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminContainersRouteRoute: AdminContainersRouteRouteWithChildren,
  AdminDevicesRouteRoute: AdminDevicesRouteRouteWithChildren,
  AdminFeatureFlagsRouteRoute: AdminFeatureFlagsRouteRouteWithChildren,
  AdminPartnersRouteRoute: AdminPartnersRouteRouteWithChildren,
  AdminWorkloadCategoriesIndexRoute: AdminWorkloadCategoriesIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface Cause_categoriesRouteRouteChildren {
  Cause_categoriesIndexRoute: typeof Cause_categoriesIndexRoute
}

const Cause_categoriesRouteRouteChildren: Cause_categoriesRouteRouteChildren = {
  Cause_categoriesIndexRoute: Cause_categoriesIndexRoute,
}

const Cause_categoriesRouteRouteWithChildren =
  Cause_categoriesRouteRoute._addFileChildren(
    Cause_categoriesRouteRouteChildren,
  )

interface ColumnsRouteRouteChildren {
  ColumnsIndexRoute: typeof ColumnsIndexRoute
  ColumnsCustomConfigurationIndexRoute: typeof ColumnsCustomConfigurationIndexRoute
  ColumnsMaterialsIndexRoute: typeof ColumnsMaterialsIndexRoute
  ColumnsStructuredConfigurationIndexRoute: typeof ColumnsStructuredConfigurationIndexRoute
}

const ColumnsRouteRouteChildren: ColumnsRouteRouteChildren = {
  ColumnsIndexRoute: ColumnsIndexRoute,
  ColumnsCustomConfigurationIndexRoute: ColumnsCustomConfigurationIndexRoute,
  ColumnsMaterialsIndexRoute: ColumnsMaterialsIndexRoute,
  ColumnsStructuredConfigurationIndexRoute:
    ColumnsStructuredConfigurationIndexRoute,
}

const ColumnsRouteRouteWithChildren = ColumnsRouteRoute._addFileChildren(
  ColumnsRouteRouteChildren,
)

interface FactoriesRouteRouteChildren {
  FactoriesIndexRoute: typeof FactoriesIndexRoute
}

const FactoriesRouteRouteChildren: FactoriesRouteRouteChildren = {
  FactoriesIndexRoute: FactoriesIndexRoute,
}

const FactoriesRouteRouteWithChildren = FactoriesRouteRoute._addFileChildren(
  FactoriesRouteRouteChildren,
)

interface FactoryRoutesRouteRouteChildren {
  FactoryRoutesIndexRoute: typeof FactoryRoutesIndexRoute
}

const FactoryRoutesRouteRouteChildren: FactoryRoutesRouteRouteChildren = {
  FactoryRoutesIndexRoute: FactoryRoutesIndexRoute,
}

const FactoryRoutesRouteRouteWithChildren =
  FactoryRoutesRouteRoute._addFileChildren(FactoryRoutesRouteRouteChildren)

interface ImportsRouteRouteChildren {
  ImportsImportIdRoute: typeof ImportsImportIdRoute
  ImportsIndexRoute: typeof ImportsIndexRoute
}

const ImportsRouteRouteChildren: ImportsRouteRouteChildren = {
  ImportsImportIdRoute: ImportsImportIdRoute,
  ImportsIndexRoute: ImportsIndexRoute,
}

const ImportsRouteRouteWithChildren = ImportsRouteRoute._addFileChildren(
  ImportsRouteRouteChildren,
)

interface InboxRouteRouteChildren {
  InboxIndexRoute: typeof InboxIndexRoute
}

const InboxRouteRouteChildren: InboxRouteRouteChildren = {
  InboxIndexRoute: InboxIndexRoute,
}

const InboxRouteRouteWithChildren = InboxRouteRoute._addFileChildren(
  InboxRouteRouteChildren,
)

interface JobCardsRouteRouteChildren {
  JobCardsJobCardIdRoute: typeof JobCardsJobCardIdRoute
  JobCardsIndexRoute: typeof JobCardsIndexRoute
}

const JobCardsRouteRouteChildren: JobCardsRouteRouteChildren = {
  JobCardsJobCardIdRoute: JobCardsJobCardIdRoute,
  JobCardsIndexRoute: JobCardsIndexRoute,
}

const JobCardsRouteRouteWithChildren = JobCardsRouteRoute._addFileChildren(
  JobCardsRouteRouteChildren,
)

interface MaterialImportsRouteRouteChildren {
  MaterialImportsMaterialImportIdRoute: typeof MaterialImportsMaterialImportIdRoute
  MaterialImportsIndexRoute: typeof MaterialImportsIndexRoute
}

const MaterialImportsRouteRouteChildren: MaterialImportsRouteRouteChildren = {
  MaterialImportsMaterialImportIdRoute: MaterialImportsMaterialImportIdRoute,
  MaterialImportsIndexRoute: MaterialImportsIndexRoute,
}

const MaterialImportsRouteRouteWithChildren =
  MaterialImportsRouteRoute._addFileChildren(MaterialImportsRouteRouteChildren)

interface MaterialsRouteRouteChildren {
  MaterialsUsageRoute: typeof MaterialsUsageRoute
  MaterialsIndexRoute: typeof MaterialsIndexRoute
}

const MaterialsRouteRouteChildren: MaterialsRouteRouteChildren = {
  MaterialsUsageRoute: MaterialsUsageRoute,
  MaterialsIndexRoute: MaterialsIndexRoute,
}

const MaterialsRouteRouteWithChildren = MaterialsRouteRoute._addFileChildren(
  MaterialsRouteRouteChildren,
)

interface OperatingCostsCostToProduceRouteRouteChildren {
  OperatingCostsCostToProduceBudgetsRoute: typeof OperatingCostsCostToProduceBudgetsRoute
  OperatingCostsCostToProduceProjectRoute: typeof OperatingCostsCostToProduceProjectRoute
  OperatingCostsCostToProduceWorkOrderRoute: typeof OperatingCostsCostToProduceWorkOrderRoute
  OperatingCostsCostToProduceIndexRoute: typeof OperatingCostsCostToProduceIndexRoute
}

const OperatingCostsCostToProduceRouteRouteChildren: OperatingCostsCostToProduceRouteRouteChildren =
  {
    OperatingCostsCostToProduceBudgetsRoute:
      OperatingCostsCostToProduceBudgetsRoute,
    OperatingCostsCostToProduceProjectRoute:
      OperatingCostsCostToProduceProjectRoute,
    OperatingCostsCostToProduceWorkOrderRoute:
      OperatingCostsCostToProduceWorkOrderRoute,
    OperatingCostsCostToProduceIndexRoute:
      OperatingCostsCostToProduceIndexRoute,
  }

const OperatingCostsCostToProduceRouteRouteWithChildren =
  OperatingCostsCostToProduceRouteRoute._addFileChildren(
    OperatingCostsCostToProduceRouteRouteChildren,
  )

interface OperatingCostsRouteRouteChildren {
  OperatingCostsCostToProduceRouteRoute: typeof OperatingCostsCostToProduceRouteRouteWithChildren
  OperatingCostsLaborRoute: typeof OperatingCostsLaborRoute
  OperatingCostsOverheadsRoute: typeof OperatingCostsOverheadsRoute
  OperatingCostsSupportRoute: typeof OperatingCostsSupportRoute
  OperatingCostsValueAddingRoute: typeof OperatingCostsValueAddingRoute
  OperatingCostsIndexRoute: typeof OperatingCostsIndexRoute
}

const OperatingCostsRouteRouteChildren: OperatingCostsRouteRouteChildren = {
  OperatingCostsCostToProduceRouteRoute:
    OperatingCostsCostToProduceRouteRouteWithChildren,
  OperatingCostsLaborRoute: OperatingCostsLaborRoute,
  OperatingCostsOverheadsRoute: OperatingCostsOverheadsRoute,
  OperatingCostsSupportRoute: OperatingCostsSupportRoute,
  OperatingCostsValueAddingRoute: OperatingCostsValueAddingRoute,
  OperatingCostsIndexRoute: OperatingCostsIndexRoute,
}

const OperatingCostsRouteRouteWithChildren =
  OperatingCostsRouteRoute._addFileChildren(OperatingCostsRouteRouteChildren)

interface OperationsRouteRouteChildren {
  OperationsOperation_idRoute: typeof OperationsOperation_idRoute
  OperationsChecksRoute: typeof OperationsChecksRoute
  OperationsNewRoute: typeof OperationsNewRoute
  OperationsIndexRoute: typeof OperationsIndexRoute
  OperationsOperation_idChecksRoute: typeof OperationsOperation_idChecksRoute
  OperationsOperation_idRun_sheetsRoute: typeof OperationsOperation_idRun_sheetsRoute
  OperationsOperation_idStationsRoute: typeof OperationsOperation_idStationsRoute
}

const OperationsRouteRouteChildren: OperationsRouteRouteChildren = {
  OperationsOperation_idRoute: OperationsOperation_idRoute,
  OperationsChecksRoute: OperationsChecksRoute,
  OperationsNewRoute: OperationsNewRoute,
  OperationsIndexRoute: OperationsIndexRoute,
  OperationsOperation_idChecksRoute: OperationsOperation_idChecksRoute,
  OperationsOperation_idRun_sheetsRoute: OperationsOperation_idRun_sheetsRoute,
  OperationsOperation_idStationsRoute: OperationsOperation_idStationsRoute,
}

const OperationsRouteRouteWithChildren = OperationsRouteRoute._addFileChildren(
  OperationsRouteRouteChildren,
)

interface OperationsStationsGridRouteRouteChildren {
  OperationsStationsGridIndexRoute: typeof OperationsStationsGridIndexRoute
}

const OperationsStationsGridRouteRouteChildren: OperationsStationsGridRouteRouteChildren =
  {
    OperationsStationsGridIndexRoute: OperationsStationsGridIndexRoute,
  }

const OperationsStationsGridRouteRouteWithChildren =
  OperationsStationsGridRouteRoute._addFileChildren(
    OperationsStationsGridRouteRouteChildren,
  )

interface PermissionsRouteRouteChildren {
  PermissionsIndexRoute: typeof PermissionsIndexRoute
}

const PermissionsRouteRouteChildren: PermissionsRouteRouteChildren = {
  PermissionsIndexRoute: PermissionsIndexRoute,
}

const PermissionsRouteRouteWithChildren =
  PermissionsRouteRoute._addFileChildren(PermissionsRouteRouteChildren)

interface ProductionPlannerRouteRouteChildren {
  ProductionPlannerTimelineRoute: typeof ProductionPlannerTimelineRoute
  ProductionPlannerIndexRoute: typeof ProductionPlannerIndexRoute
}

const ProductionPlannerRouteRouteChildren: ProductionPlannerRouteRouteChildren =
  {
    ProductionPlannerTimelineRoute: ProductionPlannerTimelineRoute,
    ProductionPlannerIndexRoute: ProductionPlannerIndexRoute,
  }

const ProductionPlannerRouteRouteWithChildren =
  ProductionPlannerRouteRoute._addFileChildren(
    ProductionPlannerRouteRouteChildren,
  )

interface ProductsContainersRouteRouteChildren {
  ProductsContainersContainerIdRoute: typeof ProductsContainersContainerIdRoute
  ProductsContainersIndexRoute: typeof ProductsContainersIndexRoute
}

const ProductsContainersRouteRouteChildren: ProductsContainersRouteRouteChildren =
  {
    ProductsContainersContainerIdRoute: ProductsContainersContainerIdRoute,
    ProductsContainersIndexRoute: ProductsContainersIndexRoute,
  }

const ProductsContainersRouteRouteWithChildren =
  ProductsContainersRouteRoute._addFileChildren(
    ProductsContainersRouteRouteChildren,
  )

interface ProductsRouteRouteChildren {
  ProductsContainersRouteRoute: typeof ProductsContainersRouteRouteWithChildren
  ProductsProductIdRoute: typeof ProductsProductIdRoute
  ProductsNewRoute: typeof ProductsNewRoute
  ProductsIndexRoute: typeof ProductsIndexRoute
}

const ProductsRouteRouteChildren: ProductsRouteRouteChildren = {
  ProductsContainersRouteRoute: ProductsContainersRouteRouteWithChildren,
  ProductsProductIdRoute: ProductsProductIdRoute,
  ProductsNewRoute: ProductsNewRoute,
  ProductsIndexRoute: ProductsIndexRoute,
}

const ProductsRouteRouteWithChildren = ProductsRouteRoute._addFileChildren(
  ProductsRouteRouteChildren,
)

interface ProjectsRouteRouteChildren {
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  ProjectsTimelineRoute: typeof ProjectsTimelineRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  ProjectsProjectIdGanttRoute: typeof ProjectsProjectIdGanttRoute
  ProjectsProjectIdRedraftRoute: typeof ProjectsProjectIdRedraftRoute
  ProjectsProjectIdReleaseRoute: typeof ProjectsProjectIdReleaseRoute
  ProjectsProjectIdRun_sheetsRoute: typeof ProjectsProjectIdRun_sheetsRoute
  ProjectsProjectIdTimelineRoute: typeof ProjectsProjectIdTimelineRoute
}

const ProjectsRouteRouteChildren: ProjectsRouteRouteChildren = {
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  ProjectsTimelineRoute: ProjectsTimelineRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  ProjectsProjectIdGanttRoute: ProjectsProjectIdGanttRoute,
  ProjectsProjectIdRedraftRoute: ProjectsProjectIdRedraftRoute,
  ProjectsProjectIdReleaseRoute: ProjectsProjectIdReleaseRoute,
  ProjectsProjectIdRun_sheetsRoute: ProjectsProjectIdRun_sheetsRoute,
  ProjectsProjectIdTimelineRoute: ProjectsProjectIdTimelineRoute,
}

const ProjectsRouteRouteWithChildren = ProjectsRouteRoute._addFileChildren(
  ProjectsRouteRouteChildren,
)

interface QualityPacksRouteRouteChildren {
  QualityPacksWorkOrderIdRoute: typeof QualityPacksWorkOrderIdRoute
  QualityPacksIndexRoute: typeof QualityPacksIndexRoute
  QualityPacksWorkOrderIdJobCardIdOrderNumberRoute: typeof QualityPacksWorkOrderIdJobCardIdOrderNumberRoute
}

const QualityPacksRouteRouteChildren: QualityPacksRouteRouteChildren = {
  QualityPacksWorkOrderIdRoute: QualityPacksWorkOrderIdRoute,
  QualityPacksIndexRoute: QualityPacksIndexRoute,
  QualityPacksWorkOrderIdJobCardIdOrderNumberRoute:
    QualityPacksWorkOrderIdJobCardIdOrderNumberRoute,
}

const QualityPacksRouteRouteWithChildren =
  QualityPacksRouteRoute._addFileChildren(QualityPacksRouteRouteChildren)

interface ShiftPatternsRouteRouteChildren {
  ShiftPatternsShift_pattern_idRoute: typeof ShiftPatternsShift_pattern_idRoute
  ShiftPatternsIndexRoute: typeof ShiftPatternsIndexRoute
}

const ShiftPatternsRouteRouteChildren: ShiftPatternsRouteRouteChildren = {
  ShiftPatternsShift_pattern_idRoute: ShiftPatternsShift_pattern_idRoute,
  ShiftPatternsIndexRoute: ShiftPatternsIndexRoute,
}

const ShiftPatternsRouteRouteWithChildren =
  ShiftPatternsRouteRoute._addFileChildren(ShiftPatternsRouteRouteChildren)

interface Vision_test_plansRouteRouteChildren {
  Vision_test_plansTest_plan_idRoute: typeof Vision_test_plansTest_plan_idRoute
  Vision_test_plansIndexRoute: typeof Vision_test_plansIndexRoute
  Vision_test_plansTest_plan_idRunsRun_idRoute: typeof Vision_test_plansTest_plan_idRunsRun_idRoute
}

const Vision_test_plansRouteRouteChildren: Vision_test_plansRouteRouteChildren =
  {
    Vision_test_plansTest_plan_idRoute: Vision_test_plansTest_plan_idRoute,
    Vision_test_plansIndexRoute: Vision_test_plansIndexRoute,
    Vision_test_plansTest_plan_idRunsRun_idRoute:
      Vision_test_plansTest_plan_idRunsRun_idRoute,
  }

const Vision_test_plansRouteRouteWithChildren =
  Vision_test_plansRouteRoute._addFileChildren(
    Vision_test_plansRouteRouteChildren,
  )

interface WorkOrdersRouteRouteChildren {
  WorkOrdersWorkOrderIdRoute: typeof WorkOrdersWorkOrderIdRoute
}

const WorkOrdersRouteRouteChildren: WorkOrdersRouteRouteChildren = {
  WorkOrdersWorkOrderIdRoute: WorkOrdersWorkOrderIdRoute,
}

const WorkOrdersRouteRouteWithChildren = WorkOrdersRouteRoute._addFileChildren(
  WorkOrdersRouteRouteChildren,
)

interface WorkforceRouteRouteChildren {
  WorkforceWorkerIdRoute: typeof WorkforceWorkerIdRoute
  WorkforceIndexRoute: typeof WorkforceIndexRoute
}

const WorkforceRouteRouteChildren: WorkforceRouteRouteChildren = {
  WorkforceWorkerIdRoute: WorkforceWorkerIdRoute,
  WorkforceIndexRoute: WorkforceIndexRoute,
}

const WorkforceRouteRouteWithChildren = WorkforceRouteRoute._addFileChildren(
  WorkforceRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  Cause_categoriesRouteRoute: Cause_categoriesRouteRouteWithChildren,
  ColumnsRouteRoute: ColumnsRouteRouteWithChildren,
  FactoriesRouteRoute: FactoriesRouteRouteWithChildren,
  FactoryRoutesRouteRoute: FactoryRoutesRouteRouteWithChildren,
  ImportsRouteRoute: ImportsRouteRouteWithChildren,
  InboxRouteRoute: InboxRouteRouteWithChildren,
  JobCardsRouteRoute: JobCardsRouteRouteWithChildren,
  MaterialImportsRouteRoute: MaterialImportsRouteRouteWithChildren,
  MaterialsRouteRoute: MaterialsRouteRouteWithChildren,
  OperatingCostsRouteRoute: OperatingCostsRouteRouteWithChildren,
  OperationsRouteRoute: OperationsRouteRouteWithChildren,
  OperationsStationsGridRouteRoute:
    OperationsStationsGridRouteRouteWithChildren,
  PermissionsRouteRoute: PermissionsRouteRouteWithChildren,
  ProductionPlannerRouteRoute: ProductionPlannerRouteRouteWithChildren,
  ProductsRouteRoute: ProductsRouteRouteWithChildren,
  ProjectsRouteRoute: ProjectsRouteRouteWithChildren,
  QualityPacksRouteRoute: QualityPacksRouteRouteWithChildren,
  ShiftPatternsRouteRoute: ShiftPatternsRouteRouteWithChildren,
  Vision_test_plansRouteRoute: Vision_test_plansRouteRouteWithChildren,
  WorkOrdersRouteRoute: WorkOrdersRouteRouteWithChildren,
  WorkforceRouteRoute: WorkforceRouteRouteWithChildren,
  NoAccessRoute: NoAccessRoute,
  Change_controlRun_idRoute: Change_controlRun_idRoute,
  AuditIndexRoute: AuditIndexRoute,
  Change_controlIndexRoute: Change_controlIndexRoute,
  DebugIndexRoute: DebugIndexRoute,
  Run_sheetsIndexRoute: Run_sheetsIndexRoute,
  DrawingsViewIdRoute: DrawingsViewIdRoute,
  Run_sheetsRulesIndexRoute: Run_sheetsRulesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
